package com.havn.app.features.properties.presentation

import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectDragGesturesAfterLongPress
import androidx.compose.foundation.gestures.scrollBy
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import com.havn.app.core.designsystem.EmptyState
import com.havn.app.core.designsystem.HavnButton
import com.havn.app.core.designsystem.HavnButtonStyle
import com.havn.app.core.designsystem.HavnCard
import com.havn.app.core.designsystem.HavnCardBorder
import com.havn.app.core.designsystem.HavnCold
import com.havn.app.core.designsystem.HavnDanger
import com.havn.app.core.designsystem.HavnGold
import com.havn.app.core.designsystem.HavnBackground
import com.havn.app.core.designsystem.HavnIcon
import com.havn.app.core.designsystem.HavnIconKey
import com.havn.app.core.designsystem.HavnInfiniteListLoadEffect
import com.havn.app.core.designsystem.HavnPullToRefreshBox
import com.havn.app.core.designsystem.HavnListDefaults
import com.havn.app.core.designsystem.HavnListFilterChip
import com.havn.app.core.designsystem.HavnMetric
import com.havn.app.core.designsystem.HavnPushNavigation
import com.havn.app.core.designsystem.HavnRefreshOverlayIndicator
import com.havn.app.core.designsystem.HavnScreenFrame
import com.havn.app.core.designsystem.HavnSearchField
import com.havn.app.core.designsystem.HavnSkeletonBlock
import com.havn.app.core.designsystem.HavnSkeletonListFooter
import com.havn.app.core.designsystem.HavnSpacing
import com.havn.app.core.designsystem.HavnStatCard
import com.havn.app.core.designsystem.HavnStatus
import com.havn.app.core.designsystem.HavnStatusBadge
import com.havn.app.core.designsystem.HavnSurfaceElevated
import com.havn.app.core.designsystem.HavnTextField
import com.havn.app.core.designsystem.HavnTextMuted
import com.havn.app.core.designsystem.HavnTextPrimary
import com.havn.app.core.designsystem.HavnTextSecondary
import com.havn.app.core.designsystem.HavnTopHeaderTextStyle
import com.havn.app.core.designsystem.HavnWebRefreshAction
import com.havn.app.core.designsystem.havnIsWebShell
import com.havn.app.core.designsystem.havnNeedsNativeTabBarContentInset
import com.havn.app.core.designsystem.havnRefreshStartGate
import com.havn.app.core.localization.LocalHavnStrings
import com.havn.app.core.media.HavnAsyncImage
import com.havn.app.core.media.HavnDatabaseImage
import com.havn.app.core.media.HavnFilePicker
import com.havn.app.core.media.HavnMediaBucket
import com.havn.app.core.media.HavnPickedFile
import com.havn.app.core.media.HavnPickedPhoto
import com.havn.app.core.media.HavnPhotoPicker
import com.havn.app.core.media.havnLargePropertyPhotoSource
import com.havn.app.core.media.havnPropertyPhotoPreviewSource
import com.havn.app.core.media.havnPublicStorageSource
import com.havn.app.core.platform.HavnExternalActions
import com.havn.app.core.platform.HavnMapCoordinate
import com.havn.app.core.platform.HavnPropertyMap
import com.havn.app.core.settings.HavnUnitPreferences
import com.havn.app.core.settings.LocalHavnUnitPreferences
import com.havn.app.core.settings.formatArea
import com.havn.app.core.settings.formatCurrency
import com.havn.app.features.agency.domain.AgencyMember
import com.havn.app.features.agency.domain.AgencyRole
import com.havn.app.features.attachments.domain.HavnAttachment
import com.havn.app.features.attachments.domain.HavnAttachmentRecipient
import com.havn.app.features.attachments.domain.HavnAttachmentRecipientSource
import com.havn.app.features.attachments.domain.HavnAttachmentSharePhoto
import com.havn.app.features.attachments.presentation.AttachmentSection
import com.havn.app.features.attachments.presentation.AttachmentsUiState
import com.havn.app.features.clients.domain.Client
import com.havn.app.features.followups.presentation.FollowUpsViewModel
import com.havn.app.features.leads.domain.Lead
import com.havn.app.features.leads.presentation.LeadDetailContent
import com.havn.app.features.openhouses.domain.LeadTemperature
import com.havn.app.features.openhouses.domain.OpenHouse
import com.havn.app.features.openhouses.domain.OpenHouseStatus
import com.havn.app.features.properties.domain.Property
import com.havn.app.features.properties.domain.PropertyPhoto
import com.havn.app.features.properties.domain.PropertyStatus
import com.havn.app.features.tasks.domain.HavnTask
import com.havn.app.features.tasks.presentation.LinkedTasksSection
import com.havn.app.ui.theme.LocalHavnThemeTokens
import kotlinx.coroutines.launch
import kotlin.math.roundToInt

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PropertiesScreen(
    viewModel: PropertiesViewModel,
    followUpsViewModel: FollowUpsViewModel,
    photoPicker: HavnPhotoPicker,
    filePicker: HavnFilePicker,
    propertyOpenings: List<OpenHouse> = emptyList(),
    attachmentsState: AttachmentsUiState = AttachmentsUiState(),
    onOpenPropertyDetail: (String) -> Unit = {},
    onScheduleOpenHouse: (String) -> Unit = {},
    onOpenOpening: (String) -> Unit = {},
    onOpenOwnerContact: (String) -> Unit = {},
    onGenerateSellerReport: (String) -> Unit = {},
    onCreateTask: (Property) -> Unit = {},
    onCreateInquiryTask: (Lead) -> Unit = {},
    onFollowUpCompleted: () -> Unit = {},
    canUseAiFollowUps: Boolean = true,
    onAiUpgradeRequired: () -> Unit = {},
    canGenerateSellerReport: Boolean = false,
    generatingSellerReportPropertyId: String? = null,
    detailBackLabel: String? = null,
    onBackFromDetail: (() -> Unit)? = null,
    linkedTasks: List<HavnTask> = emptyList(),
    onOpenTask: (String) -> Unit = {},
    onLoadAttachments: (String) -> Unit = {},
    onUploadAttachment: (Property, HavnPickedFile?) -> Unit = { _, _ -> },
    onOpenAttachment: (HavnAttachment) -> Unit = {},
    onOpenPhotoAttachment: (HavnAttachmentSharePhoto) -> Unit = {},
    onSendAttachmentEmail: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit = { _, _, _ -> },
    onSendAttachmentSms: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit = { _, _, _ -> },
    shareRecipients: List<HavnAttachmentRecipient> = emptyList(),
    isLoadingShareRecipients: Boolean = false,
    isLoadingMoreShareRecipients: Boolean = false,
    hasMoreShareRecipients: Boolean = false,
    onOpenShareRecipients: () -> Unit = {},
    onShareRecipientQueryChange: (String) -> Unit = {},
    onLoadMoreShareRecipients: () -> Unit = {},
    onDeleteAttachment: (HavnAttachment) -> Unit = {},
    onDismissAttachmentError: () -> Unit = {},
    onUpgradePlan: () -> Unit = {},
    canUseFiles: Boolean = true,
    scrollToTopSignal: Int = 0
) {
    val state by viewModel.uiState.collectAsState()
    val strings = LocalHavnStrings.current
    val unitPreferences = LocalHavnUnitPreferences.current

    HavnPushNavigation(
        targetState = state.mode,
        depthFor = PropertiesMode::navigationDepth,
        modifier = Modifier.fillMaxSize()
    ) { mode ->
        if (mode == PropertiesMode.List) {
            PropertiesListHome(
                state = state,
                onAdd = viewModel::startAdd,
                onOpen = { propertyId ->
                    viewModel.openProperty(propertyId)
                    onOpenPropertyDetail(propertyId)
                },
                onSearchChanged = viewModel::updateSearchQuery,
                onLoadMore = viewModel::loadMoreProperties,
                onRefresh = viewModel::refresh,
                onDismissError = viewModel::clearError,
                onUpgradePlan = onUpgradePlan,
                scrollToTopSignal = scrollToTopSignal
            )
            return@HavnPushNavigation
        }

        if (mode == PropertiesMode.InquiryDetail) {
            state.selectedInquiry?.let { inquiry ->
                LeadDetailContent(
                    lead = inquiry,
                    isDetailLoading = state.isLoadingInquiries,
                    isSaving = state.isSavingInquiry,
                    error = state.error,
                    followUpsViewModel = followUpsViewModel,
                    onFollowUpCompleted = onFollowUpCompleted,
                    onCreateTask = onCreateInquiryTask,
                    canUseAiFollowUps = canUseAiFollowUps,
                    onAiUpgradeRequired = onAiUpgradeRequired,
                    detailBackLabel = strings.commonInquiries,
                    onBack = viewModel::closeInquiryDetail,
                    linkedTasks = linkedTasks,
                    onOpenTask = onOpenTask,
                    onRefresh = viewModel::refreshSelectedInquiry,
                    onTemperatureSelected = { temperature ->
                        viewModel.setInquiryTemperature(inquiry.id, temperature)
                    },
                    onDismissError = viewModel::clearError
                )
            } ?: EmptyState(
                title = strings.inquiryUnavailableTitle,
                body = strings.inquiryUnavailableBody,
                actionText = strings.backToInquiries,
                onAction = viewModel::closeInquiryDetail
            )
            return@HavnPushNavigation
        }

        HavnScreenFrame(
            eyebrow = if (mode == PropertiesMode.Detail || mode == PropertiesMode.Inquiries || mode == PropertiesMode.InquiryDetail || mode == PropertiesMode.AddInquiry || mode == PropertiesMode.Add || mode == PropertiesMode.Edit || mode == PropertiesMode.Locate) "" else strings.propertiesEyebrow,
            title = when (mode) {
                PropertiesMode.List -> strings.navProperties
                PropertiesMode.Detail -> state.selectedProperty?.title ?: strings.propertyFallback
                PropertiesMode.Inquiries -> strings.propertyInquiries
                PropertiesMode.InquiryDetail -> state.selectedInquiry?.fullName ?: strings.commonInquiry
                PropertiesMode.AddInquiry -> strings.addInquiry
                PropertiesMode.Add -> strings.addProperty
                PropertiesMode.Edit -> strings.editProperty
                PropertiesMode.Locate -> strings.locateProperty
            },
            subtitle = if (mode == PropertiesMode.Detail || mode == PropertiesMode.Inquiries || mode == PropertiesMode.InquiryDetail || mode == PropertiesMode.AddInquiry || mode == PropertiesMode.Add || mode == PropertiesMode.Edit || mode == PropertiesMode.Locate) "" else strings.propertiesSubtitle,
            metrics = if (mode == PropertiesMode.Detail || mode == PropertiesMode.Inquiries || mode == PropertiesMode.InquiryDetail || mode == PropertiesMode.AddInquiry || mode == PropertiesMode.Add || mode == PropertiesMode.Edit || mode == PropertiesMode.Locate) {
                emptyList()
            } else {
                listOf(
                    HavnMetric(strings.commonActive, state.activeCount.toString(), strings.propertiesLiveMetric),
                    HavnMetric(strings.commonPlanned, state.plannedCount.toString(), strings.propertiesPipelineMetric),
                    HavnMetric(strings.commonVisitors, state.totalVisitors.toString(), strings.propertiesAllTimeMetric)
                )
            },
            backLabel = when (mode) {
                PropertiesMode.List -> null
                PropertiesMode.Detail,
                PropertiesMode.Add -> if (mode == PropertiesMode.Detail) detailBackLabel ?: strings.navProperties else strings.navProperties
                PropertiesMode.Inquiries -> state.selectedProperty?.title ?: strings.propertyFallback
                PropertiesMode.InquiryDetail -> strings.propertyInquiries
                PropertiesMode.AddInquiry -> state.selectedProperty?.title ?: strings.propertyInquiries
                PropertiesMode.Edit,
                PropertiesMode.Locate -> state.selectedProperty?.title ?: strings.propertyFallback
            },
            onBack = when (mode) {
                PropertiesMode.List -> null
                PropertiesMode.Detail -> onBackFromDetail ?: viewModel::closeDetail
                PropertiesMode.Inquiries -> viewModel::closeInquiries
                PropertiesMode.InquiryDetail -> viewModel::closeInquiryDetail
                PropertiesMode.AddInquiry -> viewModel::closeAddInquiry
                PropertiesMode.Add,
                PropertiesMode.Edit -> viewModel::cancelForm
                PropertiesMode.Locate -> viewModel::cancelLocateProperty
            },
            isRefreshing = false,
            onRefresh = null,
            headerTrailing = when (mode) {
                PropertiesMode.Detail -> state.selectedProperty?.let { property ->
                    {
                        HavnWebRefreshAction(
                            onRefresh = { viewModel.openProperty(property.id) },
                            isRefreshing = state.isDetailLoading
                        )
                    }
                }
                PropertiesMode.Inquiries -> {
                    {
                        HeaderCircleAction(
                            icon = HavnIconKey.Plus,
                            contentDescription = strings.addInquiry,
                            onClick = viewModel::showAddInquiry
                        )
                    }
                }
                else -> null
            }
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                state.error?.let { error ->
                    ErrorPanel(error = error, onDismiss = viewModel::clearError, onUpgradePlan = onUpgradePlan)
                }

                when (mode) {
                    PropertiesMode.List -> Unit
                    PropertiesMode.Detail -> state.selectedProperty?.let { property ->
                        PropertyDetail(
                            property = property,
                            isSaving = state.isSaving,
                            isDetailLoading = state.isDetailLoading,
                            isUploading = state.isUploadingPhoto,
                            strings = strings,
                            unitPreferences = unitPreferences,
                            currentAgentId = state.currentAgentId,
                            agencyMembers = state.agencyMembers,
                            assignedAgentIds = state.selectedPropertyAssignmentIds,
                            canShowTeamAccess = state.isProPlan,
                            isAssigningProperty = state.isAssigningProperty,
                            ownerContacts = state.ownerContacts,
                            inquiries = state.selectedPropertyInquiries,
                            isLoadingInquiries = state.isLoadingInquiries,
                            onOpenInquiries = viewModel::openInquiries,
                            openings = propertyOpenings.filter { it.propertyId == property.id },
                            linkedTasks = linkedTasks.filter { it.propertyId == property.id },
                            attachmentsState = attachmentsState,
                            filePicker = filePicker,
                            onAssignPropertyAccess = viewModel::assignSelectedPropertyToTeam,
                            onOwnerContactSelected = viewModel::updateSelectedPropertyOwner,
                            onOpenOwnerContact = onOpenOwnerContact,
                            onOpenOpening = onOpenOpening,
                            onGenerateSellerReport = onGenerateSellerReport,
                            onCreateTask = onCreateTask,
                            onOpenTask = onOpenTask,
                            onLoadAttachments = onLoadAttachments,
                            onUploadAttachment = onUploadAttachment,
                            onOpenAttachment = onOpenAttachment,
                            onOpenPhotoAttachment = onOpenPhotoAttachment,
                            onSendAttachmentEmail = onSendAttachmentEmail,
                            onSendAttachmentSms = onSendAttachmentSms,
                            shareRecipients = shareRecipients,
                            isLoadingShareRecipients = isLoadingShareRecipients,
                            isLoadingMoreShareRecipients = isLoadingMoreShareRecipients,
                            hasMoreShareRecipients = hasMoreShareRecipients,
                            onOpenShareRecipients = onOpenShareRecipients,
                            onShareRecipientQueryChange = onShareRecipientQueryChange,
                            onLoadMoreShareRecipients = onLoadMoreShareRecipients,
                            onDeleteAttachment = onDeleteAttachment,
                            onDismissAttachmentError = onDismissAttachmentError,
                            onUpgradePlan = onUpgradePlan,
                            canUseFiles = canUseFiles,
                            canGenerateSellerReport = canGenerateSellerReport,
                            isGeneratingSellerReport = generatingSellerReportPropertyId == property.id,
                            onEdit = { viewModel.startEdit(property.id) },
                            onScheduleOpenHouse = { onScheduleOpenHouse(property.id) },
                            onDelete = viewModel::requestDeleteSelected
                        )
                    } ?: EmptyState(
                        title = strings.propertyUnavailableTitle,
                        body = strings.propertyUnavailableBody,
                        actionText = strings.backToProperties,
                        onAction = viewModel::closeDetail
                    )

                    PropertiesMode.Inquiries -> state.selectedProperty?.let { property ->
                        PropertyInquiriesScreen(
                            property = property,
                            inquiries = state.selectedPropertyInquiries,
                            isLoading = state.isLoadingInquiries,
                            onOpenInquiry = viewModel::openInquiry,
                            onDeleteInquiry = viewModel::requestDeleteInquiry
                        )
                    } ?: EmptyState(
                        title = strings.propertyUnavailableTitle,
                        body = strings.propertyUnavailableBody,
                        actionText = strings.backToProperties,
                        onAction = viewModel::closeDetail
                    )

                    PropertiesMode.InquiryDetail -> EmptyState(
                        title = strings.inquiryUnavailableTitle,
                        body = strings.inquiryUnavailableBody,
                        actionText = strings.backToInquiries,
                        onAction = viewModel::closeInquiryDetail
                    )

                    PropertiesMode.AddInquiry -> state.selectedProperty?.let {
                        AddPropertyInquiryScreen(
                            contacts = state.ownerContacts,
                            inquiries = state.selectedPropertyInquiries,
                            form = state.inquiryForm,
                            contactQuery = state.inquiryContactQuery,
                            isSaving = state.isSavingInquiry,
                            onTemperatureSelected = { temperature ->
                                viewModel.updateInquiryForm { copy(temperature = temperature, validationError = null) }
                            },
                            onSourceChanged = { source ->
                                viewModel.updateInquiryForm { copy(source = source, validationError = null) }
                            },
                            onContactQueryChange = viewModel::updateInquiryContactQuery,
                            onContactSelected = viewModel::addInquiryContact
                        )
                    } ?: EmptyState(
                        title = strings.propertyUnavailableTitle,
                        body = strings.propertyUnavailableBody,
                        actionText = strings.backToProperties,
                        onAction = viewModel::closeDetail
                    )

                    PropertiesMode.Add,
                    PropertiesMode.Edit -> PropertyForm(
                        mode = mode,
                        form = state.form,
                        ownerContacts = state.ownerContacts,
                        agencyMembers = state.agencyMembers,
                        canShowTeamAccess = state.isProPlan,
                        isSaving = state.isSaving,
                        isUploadingPhoto = state.isUploadingPhoto,
                        canUploadPhoto = true,
                        property = state.selectedProperty,
                        strings = strings,
                        unitPreferences = unitPreferences,
                        onChange = viewModel::updateForm,
                        onSave = viewModel::saveProperty,
                        onLocateProperty = viewModel::startLocateProperty,
                        onUploadPhoto = {
                            photoPicker.pick { pickedPhoto ->
                                if (mode == PropertiesMode.Add) {
                                    viewModel.addPendingPhoto(pickedPhoto)
                                } else {
                                    viewModel.uploadHeroPhoto(pickedPhoto)
                                }
                            }
                        },
                        onRemovePendingPhoto = viewModel::removePendingPhoto,
                        onDeletePhoto = viewModel::requestDeletePhoto,
                        onReorderPhoto = viewModel::reorderPhoto,
                        onMakeMainPhoto = viewModel::makePhotoMain
                    )

                    PropertiesMode.Locate -> PropertyLocationScreen(
                        form = state.form,
                        onCoordinateChanged = { coordinate ->
                            viewModel.updatePendingLocation(coordinate.latitude, coordinate.longitude)
                        }
                    )
                }
            }
        }
    }

    if (state.showDeleteConfirmation) {
        AlertDialog(
            onDismissRequest = viewModel::dismissDeleteConfirmation,
            title = { Text(strings.deletePropertyTitle) },
            text = {
                Text(strings.deletePropertyBody)
            },
            confirmButton = {
                TextButton(onClick = viewModel::confirmDeleteSelected) {
                    Text(strings.commonDelete, color = HavnDanger)
                }
            },
            dismissButton = {
                TextButton(onClick = viewModel::dismissDeleteConfirmation) {
                    Text(strings.commonCancel)
                }
            }
        )
    }
    if (state.pendingDeletePhotoId != null) {
        AlertDialog(
            onDismissRequest = viewModel::dismissDeletePhotoConfirmation,
            title = { Text(strings.deletePhoto) },
            text = { Text("Delete this photo?") },
            confirmButton = {
                TextButton(onClick = viewModel::confirmDeletePhoto) {
                    Text(strings.commonDelete, color = HavnDanger)
                }
            },
            dismissButton = {
                TextButton(onClick = viewModel::dismissDeletePhotoConfirmation) {
                    Text(strings.commonCancel)
                }
            }
        )
    }
    state.pendingDeleteInquiryId?.let { pendingInquiryId ->
        val pendingInquiry = state.propertyInquiries.firstOrNull { it.id == pendingInquiryId }
        val pendingInquiryName = pendingInquiry?.fullName ?: strings.deleteInquiryTargetFallback
        AlertDialog(
            onDismissRequest = viewModel::dismissDeleteInquiryConfirmation,
            title = { Text(strings.deleteInquiry) },
            text = {
                Text(
                    "${strings.deleteInquiryQuestionPrefix} $pendingInquiryName ${strings.deleteInquiryQuestionSuffix}",
                    color = LocalHavnThemeTokens.current.secondaryText
                )
            },
            confirmButton = {
                TextButton(
                    onClick = viewModel::confirmDeleteInquiry,
                    enabled = !state.isSavingInquiry
                ) {
                    Text(strings.commonDelete, color = HavnDanger)
                }
            },
            dismissButton = {
                TextButton(onClick = viewModel::dismissDeleteInquiryConfirmation) {
                    Text(strings.commonCancel)
                }
            }
        )
    }
}

@Composable
private fun HeaderCircleAction(
    icon: HavnIconKey,
    contentDescription: String,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.size(44.dp),
        shape = CircleShape,
        color = theme.primaryAccent.copy(alpha = 0.14f),
        border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.5f)),
        onClick = onClick
    ) {
        Box(contentAlignment = Alignment.Center) {
            HavnIcon(icon, contentDescription = contentDescription, tint = theme.primaryAccent, modifier = Modifier.size(20.dp))
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun PropertiesListHome(
    state: PropertiesUiState,
    onAdd: () -> Unit,
    onOpen: (String) -> Unit,
    onSearchChanged: (String) -> Unit,
    onLoadMore: () -> Unit,
    onRefresh: () -> Unit,
    onDismissError: () -> Unit,
    onUpgradePlan: () -> Unit,
    scrollToTopSignal: Int
) {
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    var selectedFilter by remember { mutableStateOf(PropertyListFilter.All) }
    val filteredProperties = state.properties.filter { property ->
        val matchesStatus = when (selectedFilter) {
            PropertyListFilter.All -> true
            PropertyListFilter.Active -> property.status == PropertyStatus.Active
            PropertyListFilter.Planned -> property.status == PropertyStatus.Planned
            PropertyListFilter.Archived -> property.status == PropertyStatus.Archived
        }
        matchesStatus
    }
    val listState = rememberLazyListState()
    var handledScrollToTopSignal by remember { mutableStateOf(scrollToTopSignal) }
    LaunchedEffect(scrollToTopSignal) {
        if (scrollToTopSignal > handledScrollToTopSignal) {
            if (listState.firstVisibleItemIndex == 0 && listState.firstVisibleItemScrollOffset == 0) {
                onRefresh()
            } else {
                listState.animateScrollToItem(0)
            }
        }
        handledScrollToTopSignal = scrollToTopSignal
    }
    var gestureStartedAtTop by remember { mutableStateOf(false) }
    val bottomContentPadding = if (havnNeedsNativeTabBarContentInset) 132.dp else 18.dp
    HavnInfiniteListLoadEffect(
        listState = listState,
        enabled = state.hasMoreProperties,
        isLoading = state.isLoading || state.isLoadingMore,
        itemCount = filteredProperties.size,
        onLoadMore = onLoadMore
    )

    HavnPullToRefreshBox(
        isRefreshing = state.isLoading,
        onRefresh = {
            if (gestureStartedAtTop) {
                onRefresh()
            }
        },
        modifier = Modifier
            .fillMaxSize()
            .havnRefreshStartGate(listState) { gestureStartedAtTop = it }
    ) {
        LazyColumn(
            state = listState,
            modifier = Modifier
                .fillMaxSize()
                .background(Brush.verticalGradient(listOf(theme.gradientStart, theme.background, theme.gradientEnd))),
            contentPadding = PaddingValues(start = 18.dp, top = 18.dp, end = 18.dp, bottom = bottomContentPadding),
            verticalArrangement = Arrangement.spacedBy(HavnListDefaults.headerToSearchGap)
        ) {
            item(key = "properties-header") {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = strings.navProperties,
                        modifier = Modifier.weight(1f),
                        color = theme.primaryText,
                        style = HavnTopHeaderTextStyle
                    )
                    PropertiesIconCircleButton(
                        icon = HavnIconKey.Plus,
                        contentDescription = strings.addProperty,
                        onClick = onAdd
                    )
                }
            }

            state.error?.let { error ->
                item(key = "properties-error") {
                    ErrorPanel(error = error, onDismiss = onDismissError, onUpgradePlan = onUpgradePlan)
                }
            }

            item(key = "properties-filters") {
                Column(verticalArrangement = Arrangement.spacedBy(HavnListDefaults.searchToFilterGap)) {
                    HavnSearchField(
                        value = state.searchQuery,
                        onValueChange = onSearchChanged,
                        placeholder = strings.searchProperties
                    )

                    PropertyStatusSegments(
                        selected = selectedFilter,
                        onSelected = { selectedFilter = it }
                    )
                }
            }

            if ((!state.hasLoadedInitialPage || state.isLoading) && state.properties.isEmpty()) {
                items(6, key = { "property-skeleton-$it" }) {
                    PropertyCardSkeleton()
                }
            } else if (state.properties.isEmpty()) {
                item(key = "properties-empty") {
                    EmptyState(
                        title = strings.noPropertiesTitle,
                        body = strings.noPropertiesBody,
                        actionText = strings.addProperty,
                        onAction = onAdd
                    )
                }
            } else if (filteredProperties.isEmpty()) {
                item(key = "properties-empty-filtered") {
                    EmptyState(
                        title = strings.noMatchingPropertiesTitle,
                        body = strings.noMatchingPropertiesBody
                    )
                }
            } else {
                items(filteredProperties, key = { it.id }) { property ->
                    CompactPropertyRow(
                        property = property,
                        onClick = { onOpen(property.id) }
                    )
                }
                if (state.hasMoreProperties) {
                    item(key = "properties-loading-more") {
                        HavnSkeletonListFooter()
                    }
                }
            }
        }
    }
}

@Composable
private fun PropertiesIconCircleButton(
    icon: HavnIconKey,
    contentDescription: String,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .size(42.dp)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.large,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Box(contentAlignment = Alignment.Center) {
            HavnIcon(icon, contentDescription = contentDescription, tint = theme.primaryAccent, modifier = Modifier.size(20.dp))
        }
    }
}

private enum class PropertyListFilter {
    All,
    Active,
    Planned,
    Archived
}

@Composable
private fun PropertyStatusSegments(
    selected: PropertyListFilter,
    onSelected: (PropertyListFilter) -> Unit
) {
    val strings = LocalHavnStrings.current
    val segments = listOf(
        PropertyListFilter.All to strings.commonAll,
        PropertyListFilter.Active to strings.commonActive,
        PropertyListFilter.Planned to strings.commonPlanned,
        PropertyListFilter.Archived to strings.commonArchived
    )

    Row(
        horizontalArrangement = Arrangement.spacedBy(HavnListDefaults.filterChipGap),
        modifier = Modifier.fillMaxWidth()
    ) {
        segments.forEach { (filter, label) ->
            HavnListFilterChip(
                label = label,
                selected = selected == filter,
                onClick = { onSelected(filter) },
                modifier = Modifier.weight(1f)
            )
        }
    }
}

@Composable
private fun CompactPropertyRow(property: Property, onClick: () -> Unit) {
    val strings = LocalHavnStrings.current
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick),
        color = theme.card,
        shape = MaterialTheme.shapes.large,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Row(
            modifier = Modifier.height(112.dp)
        ) {
            Box(
                modifier = Modifier
                    .width(124.dp)
                    .fillMaxHeight()
                    .clip(RoundedCornerShape(topStart = 24.dp, bottomStart = 24.dp))
            ) {
                PropertyImageHeader(property, preferListThumbnail = true, dimImage = true)
                HavnStatusBadge(
                    status = property.status.toHavnStatus(),
                    modifier = Modifier
                        .align(Alignment.TopEnd)
                        .padding(7.dp)
                )
            }

            Box(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxHeight()
                    .padding(start = 12.dp, top = 10.dp, end = 10.dp, bottom = 10.dp)
            ) {
                Column(
                    modifier = Modifier.fillMaxSize(),
                    verticalArrangement = Arrangement.SpaceBetween
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm),
                        verticalAlignment = Alignment.Top
                    ) {
                        Column(
                            modifier = Modifier.weight(1f),
                            verticalArrangement = Arrangement.spacedBy(3.dp)
                        ) {
                            Text(
                                property.title,
                                color = theme.primaryText,
                                style = MaterialTheme.typography.titleMedium,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Text(
                                property.displayCity.ifBlank { property.displayAddress },
                                color = theme.secondaryText,
                                style = MaterialTheme.typography.bodyMedium,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }

                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(10.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        PropertyMetricItem(
                            icon = HavnIconKey.Calendar,
                            value = property.stats.openingCount.toString(),
                            label = strings.openingsTitle,
                            modifier = Modifier.weight(1f)
                        )
                        PropertyMetricItem(
                            icon = HavnIconKey.Leads,
                            value = property.stats.totalVisitors.toString(),
                            label = strings.leadsMetric.replaceFirstChar { it.uppercase() },
                            modifier = Modifier.weight(1f)
                        )
                        PropertyMetricItem(
                            icon = HavnIconKey.Mail,
                            value = property.stats.followUpsSent.toString(),
                            label = strings.commonFollowUps,
                            modifier = Modifier.weight(1.2f)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun PropertyCardSkeleton() {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.fillMaxWidth(),
        color = theme.card,
        shape = MaterialTheme.shapes.large,
        border = BorderStroke(1.dp, theme.border.copy(alpha = 0.55f))
    ) {
        Row(
            modifier = Modifier.padding(10.dp),
            horizontalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            HavnSkeletonBlock(
                modifier = Modifier
                    .width(116.dp)
                    .height(112.dp)
                    .clip(MaterialTheme.shapes.medium)
            )
            Column(
                modifier = Modifier
                    .weight(1f)
                    .height(112.dp),
                verticalArrangement = Arrangement.SpaceBetween
            ) {
                Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                    HavnSkeletonBlock(Modifier.fillMaxWidth(0.72f).height(18.dp))
                    HavnSkeletonBlock(Modifier.fillMaxWidth(0.52f).height(14.dp))
                }
                Row(horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                    repeat(3) {
                        Column(
                            modifier = Modifier.weight(1f),
                            verticalArrangement = Arrangement.spacedBy(6.dp)
                        ) {
                            HavnSkeletonBlock(Modifier.fillMaxWidth(0.45f).height(14.dp))
                            HavnSkeletonBlock(Modifier.fillMaxWidth(0.72f).height(12.dp))
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun PropertyMetricItem(
    icon: HavnIconKey,
    value: String,
    label: String,
    modifier: Modifier = Modifier
) {
    val theme = LocalHavnThemeTokens.current
    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(3.dp)
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(5.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            HavnIcon(
                icon = icon,
                contentDescription = null,
                modifier = Modifier.size(14.dp),
                tint = theme.secondaryText
            )
            Text(
                value,
                color = theme.primaryText,
                style = MaterialTheme.typography.titleSmall,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        Text(
            label,
            color = theme.mutedText,
            style = MaterialTheme.typography.labelSmall,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun PropertyDetail(
    property: Property,
    isSaving: Boolean,
    isDetailLoading: Boolean,
    isUploading: Boolean,
    strings: com.havn.app.core.localization.HavnStrings,
    unitPreferences: HavnUnitPreferences,
    currentAgentId: String?,
    agencyMembers: List<AgencyMember>,
    assignedAgentIds: List<String>,
    canShowTeamAccess: Boolean,
    isAssigningProperty: Boolean,
    ownerContacts: List<Client>,
    inquiries: List<Lead>,
    isLoadingInquiries: Boolean,
    openings: List<OpenHouse>,
    linkedTasks: List<HavnTask>,
    attachmentsState: AttachmentsUiState,
    filePicker: HavnFilePicker,
    onAssignPropertyAccess: (List<String>) -> Unit,
    onOwnerContactSelected: (String?) -> Unit,
    onOpenInquiries: () -> Unit,
    onOpenOwnerContact: (String) -> Unit,
    onOpenOpening: (String) -> Unit,
    onGenerateSellerReport: (String) -> Unit,
    onCreateTask: (Property) -> Unit,
    onOpenTask: (String) -> Unit,
    onLoadAttachments: (String) -> Unit,
    onUploadAttachment: (Property, HavnPickedFile?) -> Unit,
    onOpenAttachment: (HavnAttachment) -> Unit,
    onOpenPhotoAttachment: (HavnAttachmentSharePhoto) -> Unit,
    onSendAttachmentEmail: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit,
    onSendAttachmentSms: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit,
    shareRecipients: List<HavnAttachmentRecipient>,
    isLoadingShareRecipients: Boolean,
    isLoadingMoreShareRecipients: Boolean,
    hasMoreShareRecipients: Boolean,
    onOpenShareRecipients: () -> Unit,
    onShareRecipientQueryChange: (String) -> Unit,
    onLoadMoreShareRecipients: () -> Unit,
    onDeleteAttachment: (HavnAttachment) -> Unit,
    onDismissAttachmentError: () -> Unit,
    onUpgradePlan: () -> Unit,
    canUseFiles: Boolean,
    canGenerateSellerReport: Boolean,
    isGeneratingSellerReport: Boolean,
    onEdit: () -> Unit,
    onScheduleOpenHouse: () -> Unit,
    onDelete: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val defaultPhoto = property.photos.firstOrNull { it.storagePath == property.heroPhotoPath }
        ?: property.photos.firstOrNull { it.isHero }
        ?: property.photos.firstOrNull()
    var selectedPhotoId by remember(property.id) { mutableStateOf(defaultPhoto?.id) }
    val selectedPhoto = property.photos.firstOrNull { it.id == selectedPhotoId } ?: defaultPhoto
    LaunchedEffect(property.id) {
        onLoadAttachments(property.id)
    }
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val wide = havnIsWebShell && maxWidth >= 960.dp
        if (wide) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.lg),
                verticalAlignment = Alignment.Top
            ) {
                PropertyHeroInfoCard(
                    property = property,
                    selectedPhoto = selectedPhoto,
                    selectedPhotoId = selectedPhoto?.id,
                    strings = strings,
                    unitPreferences = unitPreferences,
                    onPhotoSelected = { selectedPhotoId = it },
                    modifier = Modifier.weight(1.55f)
                )
                PropertySidePanel(
                    property = property,
                    currentAgentId = currentAgentId,
                    agencyMembers = agencyMembers,
                    assignedAgentIds = assignedAgentIds,
                    canShowTeamAccess = canShowTeamAccess,
                    isAssigningProperty = isAssigningProperty,
                    ownerContacts = ownerContacts,
                    inquiries = inquiries,
                    isLoadingInquiries = isLoadingInquiries,
                    openings = openings,
                    linkedTasks = linkedTasks,
                    attachmentsState = attachmentsState,
                    filePicker = filePicker,
                    onAssignPropertyAccess = onAssignPropertyAccess,
                    onOwnerContactSelected = onOwnerContactSelected,
                    onOpenInquiries = onOpenInquiries,
                    onOpenOwnerContact = onOpenOwnerContact,
                    onOpenOpening = onOpenOpening,
                    onGenerateSellerReport = onGenerateSellerReport,
                    onCreateTask = onCreateTask,
                    onOpenTask = onOpenTask,
                    onUploadAttachment = onUploadAttachment,
                    onOpenAttachment = onOpenAttachment,
                    onOpenPhotoAttachment = onOpenPhotoAttachment,
                    onSendAttachmentEmail = onSendAttachmentEmail,
                    onSendAttachmentSms = onSendAttachmentSms,
                    shareRecipients = shareRecipients,
                    isLoadingShareRecipients = isLoadingShareRecipients,
                    isLoadingMoreShareRecipients = isLoadingMoreShareRecipients,
                    hasMoreShareRecipients = hasMoreShareRecipients,
                    onOpenShareRecipients = onOpenShareRecipients,
                    onShareRecipientQueryChange = onShareRecipientQueryChange,
                    onLoadMoreShareRecipients = onLoadMoreShareRecipients,
                    onDeleteAttachment = onDeleteAttachment,
                    onDismissAttachmentError = onDismissAttachmentError,
                    onUpgradePlan = onUpgradePlan,
                    canUseFiles = canUseFiles,
                    canGenerateSellerReport = canGenerateSellerReport,
                    isGeneratingSellerReport = isGeneratingSellerReport,
                    strings = strings,
                    onScheduleOpenHouse = onScheduleOpenHouse,
                    onEdit = onEdit,
                    onDelete = onDelete,
                    isSaving = isSaving,
                    modifier = Modifier.widthIn(max = 420.dp).weight(1f)
                )
            }
        } else {
            Box {
                Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                    PropertyHeroInfoCard(
                        property = property,
                        selectedPhoto = selectedPhoto,
                        selectedPhotoId = selectedPhoto?.id,
                        strings = strings,
                        unitPreferences = unitPreferences,
                        onPhotoSelected = { selectedPhotoId = it },
                        modifier = Modifier.fillMaxWidth()
                    )
                    PropertySidePanel(
                        property = property,
                        currentAgentId = currentAgentId,
                        agencyMembers = agencyMembers,
                        assignedAgentIds = assignedAgentIds,
                        canShowTeamAccess = canShowTeamAccess,
                        isAssigningProperty = isAssigningProperty,
                        ownerContacts = ownerContacts,
                        inquiries = inquiries,
                        isLoadingInquiries = isLoadingInquiries,
                        openings = openings,
                        linkedTasks = linkedTasks,
                        attachmentsState = attachmentsState,
                        filePicker = filePicker,
                        onAssignPropertyAccess = onAssignPropertyAccess,
                        onOwnerContactSelected = onOwnerContactSelected,
                        onOpenInquiries = onOpenInquiries,
                        onOpenOwnerContact = onOpenOwnerContact,
                        onOpenOpening = onOpenOpening,
                        onGenerateSellerReport = onGenerateSellerReport,
                        onCreateTask = onCreateTask,
                        onOpenTask = onOpenTask,
                        onUploadAttachment = onUploadAttachment,
                        onOpenAttachment = onOpenAttachment,
                        onOpenPhotoAttachment = onOpenPhotoAttachment,
                        onSendAttachmentEmail = onSendAttachmentEmail,
                        onSendAttachmentSms = onSendAttachmentSms,
                        shareRecipients = shareRecipients,
                        isLoadingShareRecipients = isLoadingShareRecipients,
                        isLoadingMoreShareRecipients = isLoadingMoreShareRecipients,
                        hasMoreShareRecipients = hasMoreShareRecipients,
                        onOpenShareRecipients = onOpenShareRecipients,
                        onShareRecipientQueryChange = onShareRecipientQueryChange,
                        onLoadMoreShareRecipients = onLoadMoreShareRecipients,
                        onDeleteAttachment = onDeleteAttachment,
                        onDismissAttachmentError = onDismissAttachmentError,
                        onUpgradePlan = onUpgradePlan,
                        canUseFiles = canUseFiles,
                        canGenerateSellerReport = canGenerateSellerReport,
                        isGeneratingSellerReport = isGeneratingSellerReport,
                        strings = strings,
                        onScheduleOpenHouse = onScheduleOpenHouse,
                        onEdit = onEdit,
                        onDelete = onDelete,
                        isSaving = isSaving,
                        modifier = Modifier.fillMaxWidth()
                    )
                }
                HavnRefreshOverlayIndicator(
                    isRefreshing = isDetailLoading,
                    modifier = Modifier
                        .align(Alignment.TopCenter)
                        .padding(top = 2.dp)
                )
            }
        }
    }
}

@Composable
private fun PropertyHeroInfoCard(
    property: Property,
    selectedPhoto: PropertyPhoto?,
    selectedPhotoId: String?,
    strings: com.havn.app.core.localization.HavnStrings,
    unitPreferences: HavnUnitPreferences,
    onPhotoSelected: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    val theme = LocalHavnThemeTokens.current
    HavnCard(
        modifier = modifier,
        imageHeader = {
            Box(modifier = Modifier.fillMaxSize()) {
                PropertyImageHeader(property = property, selectedPhoto = selectedPhoto, dimImage = false)
                HavnStatusBadge(
                    status = property.status.toHavnStatus(),
                    modifier = Modifier
                        .align(Alignment.TopStart)
                        .padding(HavnSpacing.md)
                )
            }
        }
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
            PropertyPhotoThumbnailStrip(
                property = property,
                selectedPhotoId = selectedPhotoId,
                onPhotoSelected = onPhotoSelected
            )
            Text(property.title, color = theme.primaryText, style = MaterialTheme.typography.headlineSmall)
            Text(property.displayAddress, color = theme.secondaryText, style = MaterialTheme.typography.bodyLarge)
            Text(property.displayCity, color = theme.mutedText, style = MaterialTheme.typography.bodyMedium)
            property.mapCoordinate()?.let { coordinate ->
                HavnButton(
                    text = strings.navigate,
                    onClick = { HavnExternalActions.openNavigation(coordinate.latitude, coordinate.longitude) },
                    style = HavnButtonStyle.Secondary,
                    modifier = Modifier.fillMaxWidth(),
                    leadingIcon = HavnIconKey.ArrowRight
                )
            }
            Text(property.askingPrice.formatCurrency(unitPreferences), color = theme.primaryAccent, style = MaterialTheme.typography.headlineMedium)
            property.interiorSqft?.let { area ->
                Text(area.formatArea(unitPreferences), color = theme.secondaryText, style = MaterialTheme.typography.bodyLarge)
            }
            property.description?.takeIf { it.isNotBlank() }?.let {
                Text(it, color = theme.secondaryText, style = MaterialTheme.typography.bodyLarge)
            }
        }
    }
}

@Composable
private fun PropertySidePanel(
    property: Property,
    currentAgentId: String?,
    agencyMembers: List<AgencyMember>,
    assignedAgentIds: List<String>,
    canShowTeamAccess: Boolean,
    isAssigningProperty: Boolean,
    ownerContacts: List<Client>,
    inquiries: List<Lead>,
    isLoadingInquiries: Boolean,
    openings: List<OpenHouse>,
    linkedTasks: List<HavnTask>,
    attachmentsState: AttachmentsUiState,
    filePicker: HavnFilePicker,
    onAssignPropertyAccess: (List<String>) -> Unit,
    onOwnerContactSelected: (String?) -> Unit,
    onOpenInquiries: () -> Unit,
    onOpenOwnerContact: (String) -> Unit,
    onOpenOpening: (String) -> Unit,
    onGenerateSellerReport: (String) -> Unit,
    onCreateTask: (Property) -> Unit,
    onOpenTask: (String) -> Unit,
    onUploadAttachment: (Property, HavnPickedFile?) -> Unit,
    onOpenAttachment: (HavnAttachment) -> Unit,
    onOpenPhotoAttachment: (HavnAttachmentSharePhoto) -> Unit,
    onSendAttachmentEmail: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit,
    onSendAttachmentSms: (List<HavnAttachmentRecipient>, List<HavnAttachment>, List<HavnAttachmentSharePhoto>) -> Unit,
    shareRecipients: List<HavnAttachmentRecipient>,
    isLoadingShareRecipients: Boolean,
    isLoadingMoreShareRecipients: Boolean,
    hasMoreShareRecipients: Boolean,
    onOpenShareRecipients: () -> Unit,
    onShareRecipientQueryChange: (String) -> Unit,
    onLoadMoreShareRecipients: () -> Unit,
    onDeleteAttachment: (HavnAttachment) -> Unit,
    onDismissAttachmentError: () -> Unit,
    onUpgradePlan: () -> Unit,
    canUseFiles: Boolean,
    canGenerateSellerReport: Boolean,
    isGeneratingSellerReport: Boolean,
    strings: com.havn.app.core.localization.HavnStrings,
    onScheduleOpenHouse: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    isSaving: Boolean,
    modifier: Modifier = Modifier
) {
    val currentMemberRole = agencyMembers.firstOrNull { it.agentId == currentAgentId }?.role
    val canAssignProperty = property.agencyId != null &&
        currentMemberRole != AgencyRole.Viewer &&
        (
            currentMemberRole == AgencyRole.Owner ||
                currentMemberRole == AgencyRole.Admin ||
                property.ownerAgentId == currentAgentId ||
                property.agentId == currentAgentId
        )
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
        ownerContacts.firstOrNull { it.id == property.ownerContactId }?.let { ownerContact ->
            PropertyOwnerContactDetailCard(
                contact = ownerContact,
                strings = strings,
                onOpen = { onOpenOwnerContact(ownerContact.id) }
            )
        }
        PropertyInquiriesCard(
            inquiries = inquiries,
            isLoading = isLoadingInquiries,
            onOpenInquiries = onOpenInquiries
        )
        PropertyOpeningsCard(
            openings = openings,
            strings = strings,
            onOpenOpening = onOpenOpening
        )
        HavnButton(
            text = strings.openHouseButton,
            onClick = onScheduleOpenHouse,
            modifier = Modifier.fillMaxWidth(),
            leadingIcon = HavnIconKey.Calendar
        )
        HavnButton(
            text = strings.createTask,
            onClick = { onCreateTask(property) },
            modifier = Modifier.fillMaxWidth(),
            style = HavnButtonStyle.Secondary,
            leadingIcon = HavnIconKey.Check
        )
        LinkedTasksSection(
            tasks = linkedTasks,
            onOpenTask = onOpenTask
        )
        AttachmentSection(
            attachments = attachmentsState.attachments.filter { it.propertyId == property.id },
            sharePhotos = property.sharePhotos(),
            shareRecipients = (shareRecipients + ownerContacts.map { it.toAttachmentRecipient() } + agencyMembers.mapNotNull { it.toAttachmentRecipient() }).dedupeAttachmentRecipients(),
            linkedShareRecipients = property.linkedAttachmentRecipients(ownerContacts, agencyMembers),
            recentShareRecipients = attachmentsState.recentRecipients,
            isLoadingShareRecipients = isLoadingShareRecipients,
            isLoadingMoreShareRecipients = isLoadingMoreShareRecipients,
            hasMoreShareRecipients = hasMoreShareRecipients,
            storageUsage = attachmentsState.storageUsage,
            currentAgentId = attachmentsState.currentAgentId,
            isUploading = attachmentsState.isUploading,
            errorMessage = attachmentsState.errorMessage,
            canUseFiles = canUseFiles,
            onDismissError = onDismissAttachmentError,
            onUpgradePlan = onUpgradePlan,
            onAttach = { filePicker.pick { file -> onUploadAttachment(property, file) } },
            onOpenAttachment = onOpenAttachment,
            onOpenPhoto = onOpenPhotoAttachment,
            onSendEmail = onSendAttachmentEmail,
            onSendSms = onSendAttachmentSms,
            onOpenShareRecipients = onOpenShareRecipients,
            onShareRecipientQueryChange = onShareRecipientQueryChange,
            onLoadMoreShareRecipients = onLoadMoreShareRecipients,
            onDelete = onDeleteAttachment
        )
        Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm), modifier = Modifier.fillMaxWidth()) {
            HavnStatCard(property.stats.totalVisitors.toString(), strings.commonVisitors, modifier = Modifier.weight(1f), icon = HavnIconKey.Users)
            HavnStatCard(property.stats.hotLeads.toString(), strings.commonHot, modifier = Modifier.weight(1f), icon = HavnIconKey.TrendUp)
        }
        Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm), modifier = Modifier.fillMaxWidth()) {
            HavnStatCard(property.stats.followUpsSent.toString(), strings.commonFollowUps, modifier = Modifier.weight(1f), icon = HavnIconKey.Mail)
            HavnStatCard("${property.stats.conversionRate.roundToInt()}%", strings.conversionMetric, modifier = Modifier.weight(1f), icon = HavnIconKey.Chart)
        }
        if (canGenerateSellerReport) {
            HavnButton(
                text = strings.generateSellerReport,
                onClick = { onGenerateSellerReport(property.id) },
                loading = isGeneratingSellerReport,
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = HavnIconKey.Reports
            )
        }
        if (canShowTeamAccess && canAssignProperty && agencyMembers.isNotEmpty()) {
            PropertyTeamAccessCard(
                members = agencyMembers,
                assignedAgentIds = assignedAgentIds,
                strings = strings,
                isSaving = isAssigningProperty,
                onSave = onAssignPropertyAccess
            )
        }
        HavnButton(
            text = strings.editProperty,
            onClick = onEdit,
            modifier = Modifier.fillMaxWidth(),
            style = HavnButtonStyle.Secondary
        )
        HavnButton(
            text = strings.deleteProperty,
            onClick = onDelete,
            modifier = Modifier.fillMaxWidth(),
            style = HavnButtonStyle.Danger,
            loading = isSaving
        )
    }
}

@Composable
private fun PropertyOwnerContactDetailCard(
    contact: Client,
    strings: com.havn.app.core.localization.HavnStrings,
    onOpen: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            Text(
                strings.propertyOwnerContactTitle,
                color = theme.primaryText,
                style = MaterialTheme.typography.titleLarge
            )
            OwnerContactRow(
                contact = contact,
                selected = false,
                onClick = onOpen,
                trailingIcon = HavnIconKey.ArrowRight
            )
        }
    }
}

@Composable
private fun PropertyTeamAccessCard(
    members: List<AgencyMember>,
    assignedAgentIds: List<String>,
    strings: com.havn.app.core.localization.HavnStrings,
    isSaving: Boolean,
    onSave: (List<String>) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    var showDialog by remember { mutableStateOf(false) }
    val assignedNames = members
        .filter { member -> member.agentId in assignedAgentIds }
        .take(3)
        .joinToString { it.fullName }
        .ifBlank { strings.onlyListingOwner }
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                HavnIcon(HavnIconKey.Users, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(18.dp))
                Text(strings.teamAccessTitle, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
            }
            Text(
                assignedNames,
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodyMedium,
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            HavnButton(
                text = strings.assignTeam,
                onClick = { showDialog = true },
                style = HavnButtonStyle.Secondary,
                loading = isSaving,
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = HavnIconKey.Sliders
            )
        }
    }

    if (showDialog) {
        PropertyTeamAccessDialog(
            members = members,
            assignedAgentIds = assignedAgentIds,
            strings = strings,
            isSaving = isSaving,
            onDismiss = { showDialog = false },
            onSave = { selectedIds ->
                showDialog = false
                onSave(selectedIds)
            }
        )
    }
}

@Composable
private fun PropertyInquiriesCard(
    inquiries: List<Lead>,
    isLoading: Boolean,
    onOpenInquiries: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    HavnCard(
        modifier = Modifier.clickable(onClick = onOpenInquiries)
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm),
                verticalAlignment = Alignment.CenterVertically
            ) {
                HavnIcon(HavnIconKey.Message, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(18.dp))
                Text(strings.commonInquiries, color = theme.primaryText, style = MaterialTheme.typography.titleMedium, modifier = Modifier.weight(1f))
                Surface(
                    shape = CircleShape,
                    color = theme.primaryAccent.copy(alpha = 0.14f),
                    border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.48f))
                ) {
                    Text(
                        inquiries.size.toString(),
                        color = theme.primaryAccent,
                        style = MaterialTheme.typography.labelLarge,
                        modifier = Modifier.padding(horizontal = 10.dp, vertical = 4.dp)
                    )
                }
            }
            Text(
                strings.propertyInquiriesBody,
                color = theme.secondaryText,
                style = MaterialTheme.typography.bodyMedium
            )
            if (isLoading && inquiries.isEmpty()) {
                repeat(2) {
                    HavnSkeletonBlock(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(72.dp),
                        shape = MaterialTheme.shapes.medium
                    )
                }
            } else if (inquiries.isEmpty()) {
                Surface(
                    shape = MaterialTheme.shapes.medium,
                    color = theme.surface.copy(alpha = 0.62f),
                    border = BorderStroke(1.dp, theme.border.copy(alpha = 0.68f))
                ) {
                    Text(
                        strings.propertyInquiriesEmpty,
                        color = theme.secondaryText,
                        style = MaterialTheme.typography.bodyMedium,
                        modifier = Modifier.padding(HavnSpacing.md)
                    )
                }
            } else {
                inquiries.take(3).forEach { inquiry ->
                    PropertyInquiryRow(inquiry = inquiry, onClick = onOpenInquiries)
                }
            }
            HavnButton(
                text = if (inquiries.size > 3) "${strings.viewInquiries} (${inquiries.size})" else strings.viewInquiries,
                onClick = onOpenInquiries,
                modifier = Modifier.fillMaxWidth(),
                style = HavnButtonStyle.Secondary,
                leadingIcon = HavnIconKey.ArrowRight
            )
        }
    }
}

@Composable
private fun PropertyInquiryRow(
    inquiry: Lead,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val avatarSource = inquiry.avatarThumbnailDataUrl ?: inquiry.avatarDataUrl
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.medium,
        color = theme.surface.copy(alpha = 0.62f),
        border = BorderStroke(1.dp, theme.border.copy(alpha = 0.68f))
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.sm),
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Surface(
                modifier = Modifier.size(42.dp),
                shape = CircleShape,
                color = theme.primaryAccent.copy(alpha = 0.14f),
                border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.42f))
            ) {
                Box(contentAlignment = Alignment.Center) {
                    val rendered = HavnAsyncImage(
                        dataUrl = avatarSource,
                        contentDescription = inquiry.fullName,
                        modifier = Modifier.fillMaxSize(),
                        contentScale = ContentScale.Crop
                    )
                    if (!rendered) {
                        Text(
                            inquiry.fullName.initials(),
                            color = theme.primaryAccent,
                            style = MaterialTheme.typography.labelLarge
                        )
                    }
                }
            }
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(inquiry.fullName, color = theme.primaryText, style = MaterialTheme.typography.titleSmall, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Text(
                    listOf(strings.commonInquiry, inquiry.updatedAt?.displayDateTime() ?: inquiry.createdAt?.displayDateTime()).filterNotNull().joinToString(" · "),
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.labelMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                inquiry.notes?.takeIf { it.isNotBlank() }?.let {
                    Text(it, color = theme.mutedText, style = MaterialTheme.typography.labelSmall, maxLines = 1, overflow = TextOverflow.Ellipsis)
                }
            }
            HavnIcon(HavnIconKey.ArrowRight, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(16.dp))
        }
    }
}

@Composable
private fun PropertyInquiriesScreen(
    property: Property,
    inquiries: List<Lead>,
    isLoading: Boolean,
    onOpenInquiry: (String) -> Unit,
    onDeleteInquiry: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    var query by remember(property.id) { mutableStateOf("") }
    var selectedTemperature by remember(property.id) { mutableStateOf<LeadTemperature?>(null) }
    val filtered = inquiries.filter { inquiry ->
        val normalized = query.trim().lowercase()
        val matchesQuery = normalized.isBlank() ||
            listOf(
                inquiry.fullName,
                inquiry.contactLine,
                inquiry.notes.orEmpty()
            ).any { normalized in it.lowercase() }
        val matchesTemperature = selectedTemperature == null || inquiry.temperature == selectedTemperature
        matchesQuery && matchesTemperature
    }

    Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
        HavnSearchField(
            value = query,
            onValueChange = { query = it },
            placeholder = strings.searchInquiries
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(HavnListDefaults.filterChipGap)
        ) {
            HavnListFilterChip(
                label = strings.commonAll,
                selected = selectedTemperature == null,
                onClick = { selectedTemperature = null },
                modifier = Modifier.weight(0.8f)
            )
            LeadTemperature.entries.forEach { temperature ->
                HavnListFilterChip(
                    label = temperature.localizedInquiryLabel(strings),
                    selected = selectedTemperature == temperature,
                    onClick = { selectedTemperature = temperature },
                    modifier = Modifier.weight(1f)
                )
            }
        }
        if (isLoading && inquiries.isEmpty()) {
            repeat(6) {
                HavnSkeletonBlock(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(78.dp),
                    shape = MaterialTheme.shapes.medium
                )
            }
        } else if (filtered.isEmpty()) {
            EmptyState(
                title = strings.noInquiries,
                body = strings.noInquiriesBody,
                actionText = null,
                onAction = {}
            )
        } else {
            filtered.forEach { inquiry ->
                PropertyInquiryTableRow(
                    inquiry = inquiry,
                    onClick = { onOpenInquiry(inquiry.id) },
                    onDelete = { onDeleteInquiry(inquiry.id) }
                )
            }
        }
    }
}

@Composable
private fun PropertyInquiryTableRow(
    inquiry: Lead,
    onClick: () -> Unit,
    onDelete: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val avatarSource = inquiry.avatarSource()
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.medium,
        color = theme.card.copy(alpha = 0.82f),
        border = BorderStroke(1.dp, theme.border.copy(alpha = 0.7f))
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.md),
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md),
            verticalAlignment = Alignment.CenterVertically
        ) {
            InquiryAvatar(inquiry = inquiry, avatarSource = avatarSource, size = 52.dp)
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                Text(inquiry.fullName, color = theme.primaryText, style = MaterialTheme.typography.titleMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Text(inquiry.contactLine, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Text(
                    listOf(strings.commonInquiry, inquiry.updatedAt?.displayDateTime() ?: inquiry.createdAt?.displayDateTime()).filterNotNull().joinToString(" · "),
                    color = theme.mutedText,
                    style = MaterialTheme.typography.labelMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            Column(horizontalAlignment = Alignment.End, verticalArrangement = Arrangement.spacedBy(6.dp)) {
                HavnStatusBadge(inquiry.temperature.toHavnStatus())
                Surface(
                    modifier = Modifier
                        .size(36.dp)
                        .clip(CircleShape)
                        .clickable(onClick = onDelete),
                    shape = CircleShape,
                    color = HavnDanger.copy(alpha = 0.12f),
                    border = BorderStroke(1.dp, HavnDanger.copy(alpha = 0.4f))
                ) {
                    Box(contentAlignment = Alignment.Center) {
                        HavnIcon(
                            HavnIconKey.Trash,
                            contentDescription = strings.deleteInquiry,
                            tint = HavnDanger,
                            modifier = Modifier.size(18.dp)
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun InquiryAvatar(inquiry: Lead, avatarSource: String?, size: androidx.compose.ui.unit.Dp) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.size(size),
        shape = CircleShape,
        color = theme.primaryAccent.copy(alpha = 0.14f),
        border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.42f))
    ) {
        Box(contentAlignment = Alignment.Center) {
            val rendered = HavnAsyncImage(
                dataUrl = avatarSource,
                contentDescription = inquiry.fullName,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Crop
            )
            if (!rendered) {
                Text(
                    inquiry.fullName.initials(),
                    color = theme.primaryAccent,
                    style = MaterialTheme.typography.labelLarge
                )
            }
        }
    }
}

private fun Lead.avatarSource(): String? = avatarThumbnailDataUrl ?: avatarDataUrl

@Composable
private fun PropertyOpeningsCard(
    openings: List<OpenHouse>,
    strings: com.havn.app.core.localization.HavnStrings,
    onOpenOpening: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm),
                verticalAlignment = Alignment.CenterVertically
            ) {
                HavnIcon(HavnIconKey.CalendarClock, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(18.dp))
                Text(strings.propertyOpeningsTitle, color = theme.primaryText, style = MaterialTheme.typography.titleMedium)
            }
            if (openings.isEmpty()) {
                Text(strings.propertyNoOpenings, color = theme.secondaryText, style = MaterialTheme.typography.bodyMedium)
            } else {
                openings.sortedByDescending { it.startsAt }.forEach { opening ->
                    PropertyOpeningRow(opening = opening, onClick = { onOpenOpening(opening.id) })
                }
            }
        }
    }
}

@Composable
private fun PropertyOpeningRow(
    opening: OpenHouse,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.medium,
        color = theme.surface.copy(alpha = 0.62f),
        border = BorderStroke(1.dp, theme.border.copy(alpha = 0.68f))
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.sm),
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm),
            verticalAlignment = Alignment.CenterVertically
        ) {
            HavnIcon(HavnIconKey.Calendar, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(18.dp))
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(opening.displayTitle, color = theme.primaryText, style = MaterialTheme.typography.titleSmall, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Text("${opening.startsAt.displayDateTime()} - ${opening.endsAt.displayDateTime()}", color = theme.secondaryText, style = MaterialTheme.typography.labelMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
            }
            HavnStatusBadge(status = opening.status.toHavnStatus())
            HavnIcon(HavnIconKey.ArrowRight, contentDescription = null, tint = theme.primaryAccent, modifier = Modifier.size(16.dp))
        }
    }
}

private fun OpenHouseStatus.toHavnStatus(): HavnStatus = when (this) {
    OpenHouseStatus.Live -> HavnStatus.Active
    OpenHouseStatus.Completed,
    OpenHouseStatus.Cancelled -> HavnStatus.Archived
    OpenHouseStatus.Scheduled -> HavnStatus.Planned
}

private fun LeadTemperature.toHavnStatus(): HavnStatus = when (this) {
    LeadTemperature.Hot -> HavnStatus.Hot
    LeadTemperature.Warm -> HavnStatus.Warm
    LeadTemperature.Cold -> HavnStatus.Cold
}

private fun LeadTemperature.temperatureAccent(): Color = when (this) {
    LeadTemperature.Hot -> Color(0xFFE85D4A)
    LeadTemperature.Warm -> Color(0xFFD99A32)
    LeadTemperature.Cold -> Color(0xFF35C9D0)
}

private fun LeadTemperature.temperatureContentColor(defaultTextColor: Color): Color =
    if (this == LeadTemperature.Cold) Color(0xFF031316) else defaultTextColor

private fun LeadTemperature.localizedInquiryLabel(strings: com.havn.app.core.localization.HavnStrings): String = when (this) {
    LeadTemperature.Hot -> strings.commonHot
    LeadTemperature.Warm -> strings.commonWarm
    LeadTemperature.Cold -> strings.commonCold
}

@Composable
private fun AddPropertyInquiryScreen(
    contacts: List<Client>,
    inquiries: List<Lead>,
    form: PropertyInquiryFormState,
    contactQuery: String,
    isSaving: Boolean,
    onTemperatureSelected: (LeadTemperature) -> Unit,
    onSourceChanged: (String) -> Unit,
    onContactQueryChange: (String) -> Unit,
    onContactSelected: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val inquiryContactIds = remember(inquiries) { inquiries.map { it.contactId }.toSet() }
    val sortedContacts = remember(contacts) {
        contacts.sortedWith(
            compareBy<Client> { it.lastName?.lowercase().orEmpty() }
                .thenBy { it.firstName?.lowercase().orEmpty() }
                .thenBy { it.fullName.lowercase() }
        )
    }
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            Text(strings.selectClients, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
            HavnSearchField(
                value = contactQuery,
                onValueChange = onContactQueryChange,
                placeholder = strings.searchContacts
            )
            InquiryLeadTemperatureSelector(
                selectedTemperature = form.temperature,
                enabled = !isSaving,
                onTemperatureSelected = onTemperatureSelected
            )
            HavnTextField(
                value = form.source,
                onValueChange = onSourceChanged,
                label = strings.leadSource
            )
            if (contacts.isEmpty()) {
                Surface(
                    shape = MaterialTheme.shapes.medium,
                    color = theme.surface,
                    border = BorderStroke(1.dp, theme.border)
                ) {
                    Text(
                        strings.createContactFirstForInquiry,
                        color = theme.secondaryText,
                        style = MaterialTheme.typography.bodyMedium,
                        modifier = Modifier.padding(HavnSpacing.md)
                    )
                }
            } else {
                sortedContacts.forEach { contact ->
                    val alreadyAdded = contact.id in inquiryContactIds
                    InquiryContactPickerRow(
                        contact = contact,
                        selected = alreadyAdded || form.contactId == contact.id,
                        actionLabel = if (alreadyAdded) strings.commonCheckedIn else strings.commonAdd,
                        enabled = !alreadyAdded && !isSaving,
                        onClick = { onContactSelected(contact.id) }
                    )
                }
            }
            form.validationError?.let {
                Text(it, color = HavnDanger, style = MaterialTheme.typography.labelMedium)
            }
        }
    }
}

@Composable
private fun InquiryContactPickerRow(
    contact: Client,
    selected: Boolean,
    actionLabel: String,
    enabled: Boolean,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .then(if (enabled) Modifier.clickable(onClick = onClick) else Modifier),
        color = if (selected) theme.primaryAccent.copy(alpha = 0.14f) else theme.surface,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border),
        shape = MaterialTheme.shapes.medium
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
        ) {
            Surface(
                modifier = Modifier.size(34.dp),
                shape = CircleShape,
                color = if (selected) theme.primaryAccent else theme.surfaceElevated,
                border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
            ) {
                Box(contentAlignment = Alignment.Center) {
                    HavnIcon(
                        icon = if (selected) HavnIconKey.Check else HavnIconKey.User,
                        contentDescription = null,
                        tint = if (selected) theme.background else theme.secondaryText,
                        modifier = Modifier.size(16.dp)
                    )
                }
            }
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(contact.fullName, color = theme.primaryText, style = MaterialTheme.typography.bodyLarge, maxLines = 1, overflow = TextOverflow.Ellipsis)
                Text(contact.contactLine, color = theme.secondaryText, style = MaterialTheme.typography.labelMedium, maxLines = 1, overflow = TextOverflow.Ellipsis)
            }
            Text(
                text = actionLabel,
                color = if (enabled) theme.primaryAccent else theme.secondaryText,
                style = MaterialTheme.typography.titleSmall,
                fontWeight = FontWeight.SemiBold,
                maxLines = 1
            )
        }
    }
}

@Composable
private fun InquiryLeadTemperatureSelector(
    selectedTemperature: LeadTemperature,
    enabled: Boolean,
    onTemperatureSelected: (LeadTemperature) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = MaterialTheme.shapes.medium,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(3.dp),
            horizontalArrangement = Arrangement.spacedBy(4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            LeadTemperature.entries.forEach { temperature ->
                InquiryLeadTemperatureChip(
                    label = temperature.localizedInquiryLabel(strings),
                    temperature = temperature,
                    selected = selectedTemperature == temperature,
                    enabled = enabled,
                    onClick = { onTemperatureSelected(temperature) },
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}

@Composable
private fun InquiryLeadTemperatureChip(
    label: String,
    temperature: LeadTemperature,
    selected: Boolean,
    enabled: Boolean,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val theme = LocalHavnThemeTokens.current
    val accent = temperature.temperatureAccent()
    val background = if (selected) accent else accent.copy(alpha = 0.16f)
    val contentColor = if (selected) temperature.temperatureContentColor(theme.primaryText) else accent
    Surface(
        shape = RoundedCornerShape(9.dp),
        color = if (enabled) background else theme.card,
        border = BorderStroke(1.dp, if (selected) contentColor.copy(alpha = 0.55f) else accent.copy(alpha = 0.46f)),
        modifier = modifier
            .height(HavnListDefaults.filterChipHeight)
            .clip(RoundedCornerShape(9.dp))
            .then(if (enabled) Modifier.clickable(onClick = onClick) else Modifier)
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = 4.dp),
            contentAlignment = Alignment.Center
        ) {
            Text(
                text = label,
                color = if (enabled) contentColor else theme.mutedText,
                style = MaterialTheme.typography.labelMedium,
                fontWeight = FontWeight.SemiBold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
private fun PropertyTeamAccessDialog(
    members: List<AgencyMember>,
    assignedAgentIds: List<String>,
    strings: com.havn.app.core.localization.HavnStrings,
    isSaving: Boolean,
    onDismiss: () -> Unit,
    onSave: (List<String>) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    var selectedIds by remember(assignedAgentIds, members) { mutableStateOf(assignedAgentIds.toSet()) }
    var query by remember { mutableStateOf("") }
    val sortedMembers = remember(members) { members.sortedForAgentPicker() }
    val filteredMembers = remember(sortedMembers, query) {
        val normalizedQuery = query.trim().lowercase()
        if (normalizedQuery.isBlank()) {
            sortedMembers
        } else {
            sortedMembers.filter { member ->
                member.fullName.contains(normalizedQuery, ignoreCase = true) ||
                    member.email.contains(normalizedQuery, ignoreCase = true) ||
                    member.role.displayName.contains(normalizedQuery, ignoreCase = true)
            }
        }
    }
    val activeMemberIds = sortedMembers.mapNotNull { it.agentId }.toSet()
    AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = theme.card,
        title = { Text(strings.assignPropertyTitle, color = theme.primaryText) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                Text(
                    strings.assignPropertyBody,
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.bodyMedium
                )
                HavnSearchField(
                    value = query,
                    onValueChange = { query = it },
                    placeholder = strings.agents
                )
                PropertyAssigneeRow(
                    title = strings.wholeTeam,
                    subtitle = "${sortedMembers.size} ${strings.activeMembers}",
                    selected = selectedIds.containsAll(activeMemberIds),
                    onClick = { selectedIds = activeMemberIds }
                )
                LazyColumn(
                    modifier = Modifier.heightIn(max = 340.dp),
                    verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                ) {
                    items(filteredMembers, key = { it.agentId ?: it.email }) { member ->
                        val memberAgentId = member.agentId ?: return@items
                        PropertyAssigneeRow(
                            title = member.fullName,
                            subtitle = "${member.role.displayName} · ${member.email}",
                            selected = memberAgentId in selectedIds,
                            onClick = {
                                selectedIds = if (memberAgentId in selectedIds) {
                                    selectedIds - memberAgentId
                                } else {
                                    selectedIds + memberAgentId
                                }
                            }
                        )
                    }
                }
            }
        },
        confirmButton = {
            TextButton(
                onClick = { onSave(selectedIds.toList()) },
                enabled = !isSaving
            ) {
                Text(strings.commonSave, color = theme.primaryAccent)
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text(strings.commonCancel, color = theme.secondaryText)
            }
        }
    )
}

private fun List<AgencyMember>.sortedForAgentPicker(): List<AgencyMember> = filter { it.agentId != null }.sortedWith(
    compareBy<AgencyMember> { it.status.name }
        .thenBy { it.fullName.lowercase() }
        .thenBy { it.email.lowercase() }
)

@Composable
private fun PropertyAssigneeRow(
    title: String,
    subtitle: String,
    selected: Boolean,
    onClick: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickable(onClick = onClick),
        color = if (selected) theme.primaryAccent.copy(alpha = 0.14f) else theme.surface,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border),
        shape = MaterialTheme.shapes.medium
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
        ) {
            Surface(
                modifier = Modifier.size(34.dp),
                shape = CircleShape,
                color = if (selected) theme.primaryAccent else theme.surfaceElevated,
                border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
            ) {
                Box(contentAlignment = Alignment.Center) {
                    HavnIcon(
                        icon = if (selected) HavnIconKey.Check else HavnIconKey.Users,
                        contentDescription = null,
                        tint = if (selected) theme.background else theme.secondaryText,
                        modifier = Modifier.size(16.dp)
                    )
                }
            }
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(title, color = theme.primaryText, style = MaterialTheme.typography.bodyLarge)
                Text(subtitle, color = theme.secondaryText, style = MaterialTheme.typography.labelMedium)
            }
        }
    }
}

@Composable
private fun PropertyPhotoThumbnailStrip(property: Property) {
    PropertyPhotoThumbnailStrip(
        property = property,
        selectedPhotoId = property.photos.firstOrNull { it.storagePath == property.heroPhotoPath }?.id
            ?: property.photos.firstOrNull { it.isHero }?.id
            ?: property.photos.firstOrNull()?.id,
        onPhotoSelected = {}
    )
}

@Composable
private fun PropertyPhotoThumbnailStrip(
    property: Property,
    selectedPhotoId: String?,
    onPhotoSelected: (String) -> Unit
) {
    val photos = property.photos
    val theme = LocalHavnThemeTokens.current
    if (photos.size <= 1) return

    LazyRow(
        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm),
        modifier = Modifier.fillMaxWidth()
    ) {
        items(photos, key = { it.id }) { photo ->
            val isMain = photo.id == selectedPhotoId
            Box(
                modifier = Modifier
                    .size(58.dp)
                    .clip(MaterialTheme.shapes.medium)
                    .clickable { onPhotoSelected(photo.id) }
                    .border(
                        width = if (isMain) 2.dp else 1.dp,
                        color = if (isMain) theme.primaryAccent else theme.border,
                        shape = MaterialTheme.shapes.medium
                    )
                    .background(theme.surface)
            ) {
                val rendered = HavnDatabaseImage(
                    dataUrl = photo.thumbnailDataUrl,
                    previewDataUrl = havnPropertyPhotoPreviewSource(photo.thumbnailDataUrl, 88),
                    contentDescription = photo.altText ?: property.title,
                    modifier = Modifier.fillMaxSize(),
                    contentScale = ContentScale.Crop
                )
                if (!rendered) {
                    HavnIcon(
                        icon = HavnIconKey.Properties,
                        contentDescription = null,
                        tint = theme.primaryAccent,
                        modifier = Modifier
                            .align(Alignment.Center)
                            .size(22.dp)
                    )
                }
            }
        }
    }
}

private fun Property.sharePhotos(): List<HavnAttachmentSharePhoto> =
    photos.mapNotNull { photo ->
        val url = havnPublicStorageSource(HavnMediaBucket.PropertyPhotos, photo.storagePath) ?: return@mapNotNull null
        HavnAttachmentSharePhoto(
            id = photo.id,
            title = photo.altText?.takeIf { it.isNotBlank() } ?: "$title photo",
            url = url,
            thumbnailDataUrl = photo.thumbnailDataUrl,
            bucketId = HavnMediaBucket.PropertyPhotos,
            storagePath = photo.storagePath,
            contentType = photo.contentType
        )
    }

private fun Property.linkedAttachmentRecipients(
    contacts: List<Client>,
    members: List<AgencyMember>
): List<HavnAttachmentRecipient> = buildList {
    contacts.firstOrNull { it.id == ownerContactId }?.toAttachmentRecipient()?.let(::add)
    contacts
        .filter { contact -> contact.openings.any { it.propertyId == id } }
        .map { it.toAttachmentRecipient() }
        .forEach(::add)
    members.mapNotNull { it.toAttachmentRecipient() }.forEach(::add)
}.dedupeAttachmentRecipients()

private fun Client.toAttachmentRecipient(): HavnAttachmentRecipient = HavnAttachmentRecipient(
    id = "contact:$id",
    displayName = fullName,
    email = email,
    phone = phone,
    source = HavnAttachmentRecipientSource.Contact
)

private fun AgencyMember.toAttachmentRecipient(): HavnAttachmentRecipient? {
    val memberId = agentId ?: invitationId ?: email.takeIf { it.isNotBlank() } ?: return null
    return HavnAttachmentRecipient(
        id = "agent:$memberId",
        displayName = fullName,
        email = email.takeIf { it.isNotBlank() },
        phone = null,
        source = HavnAttachmentRecipientSource.Agent
    )
}

private fun List<HavnAttachmentRecipient>.dedupeAttachmentRecipients(): List<HavnAttachmentRecipient> =
    distinctBy { it.id }

@Composable
private fun PropertyForm(
    mode: PropertiesMode,
    form: PropertyFormState,
    ownerContacts: List<Client>,
    agencyMembers: List<AgencyMember>,
    canShowTeamAccess: Boolean,
    isSaving: Boolean,
    isUploadingPhoto: Boolean,
    canUploadPhoto: Boolean,
    property: Property?,
    strings: com.havn.app.core.localization.HavnStrings,
    unitPreferences: HavnUnitPreferences,
    onChange: (PropertyFormState.() -> PropertyFormState) -> Unit,
    onSave: () -> Unit,
    onLocateProperty: () -> Unit,
    onUploadPhoto: () -> Unit,
    onRemovePendingPhoto: (Int) -> Unit,
    onDeletePhoto: (String) -> Unit,
    onReorderPhoto: (String, Int) -> Unit,
    onMakeMainPhoto: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val actionButtonModifier = Modifier.fillMaxWidth()
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            form.validationError?.let {
                Text(it.localizedPropertyValidation(strings), color = HavnDanger, style = MaterialTheme.typography.bodyMedium)
            }
            HavnTextField(form.title, { value -> onChange { copy(title = value, validationError = null) } }, strings.propertyTitleLabel)
            HavnTextField(form.addressLine1, { value -> onChange { copy(addressLine1 = value, validationError = null) } }, strings.propertyAddressLine1Label)
            HavnTextField(form.addressLine2, { value -> onChange { copy(addressLine2 = value) } }, strings.propertyAddressLine2Label)
            Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                HavnTextField(
                    value = form.city,
                    onValueChange = { value -> onChange { copy(city = value, validationError = null) } },
                    label = strings.propertyCityLabel,
                    modifier = Modifier.weight(1f)
                )
                HavnTextField(
                    value = form.region,
                    onValueChange = { value -> onChange { copy(region = value, validationError = null) } },
                    label = strings.propertyRegionLabel,
                    modifier = Modifier.weight(1f)
                )
            }
            Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                HavnTextField(
                    value = form.postalCode,
                    onValueChange = { value -> onChange { copy(postalCode = value, validationError = null) } },
                    label = strings.propertyPostalCodeLabel,
                    modifier = Modifier.weight(1f),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number)
                )
                HavnTextField(
                    value = form.country,
                    onValueChange = { value -> onChange { copy(country = value) } },
                    label = strings.propertyCountryLabel,
                    modifier = Modifier.weight(1f)
                )
            }
            if (mode == PropertiesMode.Edit) {
                HavnButton(
                    text = strings.locateProperty,
                    onClick = onLocateProperty,
                    style = HavnButtonStyle.Secondary,
                    modifier = actionButtonModifier,
                    leadingIcon = HavnIconKey.Home
                )
                form.locationLabel()?.let { location ->
                    Text(location, color = theme.mutedText, style = MaterialTheme.typography.bodySmall)
                }
            }
            HavnTextField(
                value = form.askingPrice,
                onValueChange = { value -> onChange { copy(askingPrice = value.filter { it.isDigit() }, validationError = null) } },
                label = "${strings.propertyAskingPriceLabel} (${unitPreferences.currency.code})",
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                leadingIcon = HavnIconKey.Chart
            )
            Row(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                HavnTextField(
                    value = form.bedrooms,
                    onValueChange = { value -> onChange { copy(bedrooms = value.numberText()) } },
                    label = strings.propertyBedsLabel,
                    modifier = Modifier.weight(1f),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal)
                )
                HavnTextField(
                    value = form.bathrooms,
                    onValueChange = { value -> onChange { copy(bathrooms = value.numberText()) } },
                    label = strings.propertyBathsLabel,
                    modifier = Modifier.weight(1f),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal)
                )
                HavnTextField(
                    value = form.interiorSqft,
                    onValueChange = { value -> onChange { copy(interiorSqft = value.filter { it.isDigit() }) } },
                    label = "${strings.propertyInteriorLabel} ${unitPreferences.areaLabel}",
                    modifier = Modifier.weight(1f),
                    keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number)
                )
            }
            StatusPicker(form.status, strings) { status -> onChange { copy(status = status) } }
            HavnTextField(
                value = form.description,
                onValueChange = { value -> onChange { copy(description = value) } },
                label = strings.propertyDescriptionLabel,
                singleLine = false
            )
        }
    }

    PropertyOwnerContactCard(
        contacts = ownerContacts,
        selectedContactId = form.ownerContactId,
        strings = strings,
        onSelect = { contactId -> onChange { copy(ownerContactId = contactId) } }
    )

    if (canShowTeamAccess && mode == PropertiesMode.Add && agencyMembers.isNotEmpty()) {
        PropertyTeamAccessCard(
            members = agencyMembers,
            assignedAgentIds = form.assignedAgentIds,
            strings = strings,
            isSaving = false,
            onSave = { agentIds -> onChange { copy(assignedAgentIds = agentIds.distinct()) } }
        )
    }

    if (canUploadPhoto) {
        HavnCard {
            Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                Text(strings.photosTitle, color = theme.primaryText, style = MaterialTheme.typography.titleLarge)
                Text(
                    strings.photosBody,
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.bodyMedium
                )
                HavnButton(
                    text = strings.uploadPhoto,
                    onClick = onUploadPhoto,
                    style = HavnButtonStyle.Secondary,
                    loading = isUploadingPhoto,
                    enabled = !isUploadingPhoto,
                    modifier = actionButtonModifier,
                    leadingIcon = HavnIconKey.Plus
                )
                val photos = property?.photos.orEmpty().orderedBy(form.photoOrderIds)
                val pendingPhotos = form.pendingPhotos
                if (mode == PropertiesMode.Add && pendingPhotos.isNotEmpty()) {
                    LazyRow(horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
                        itemsIndexed(pendingPhotos) { index, photo ->
                            PendingPropertyPhotoTile(
                                photo = photo,
                                index = index,
                                mainLabel = strings.mainPhoto,
                                removeLabel = strings.deletePhoto,
                                onRemove = { onRemovePendingPhoto(index) }
                            )
                        }
                    }
                } else if (photos.isEmpty()) {
                    Text(
                        strings.noPhotosYet,
                        color = theme.mutedText,
                        style = MaterialTheme.typography.bodyMedium
                    )
                } else {
                    val photoListState = rememberLazyListState()
                    val dragScrollScope = rememberCoroutineScope()
                    LazyRow(
                        state = photoListState,
                        horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm),
                        contentPadding = PaddingValues(horizontal = 22.dp, vertical = 18.dp)
                    ) {
                        items(photos, key = { it.id }) { photo ->
                            val index = photos.indexOfFirst { it.id == photo.id }
                            PropertyPhotoTile(
                                photo = photo,
                                index = index,
                                mainLabel = strings.mainPhoto,
                                imageDescription = strings.propertyPhotoContentDescription,
                                deleteDescription = strings.deletePhoto,
                                onDelete = { onDeletePhoto(photo.id) },
                                onReorder = { targetIndex -> onReorderPhoto(photo.id, targetIndex) },
                                onMakeMain = { onMakeMainPhoto(photo.id) },
                                onDragScroll = { scrollDelta ->
                                    dragScrollScope.launch { photoListState.scrollBy(scrollDelta) }
                                }
                            )
                        }
                    }
                }
            }
        }
    }

    HavnButton(
        text = if (mode == PropertiesMode.Add) strings.createPropertyButton else strings.commonSave,
        onClick = onSave,
        modifier = actionButtonModifier,
        loading = isSaving,
        leadingIcon = HavnIconKey.Check
    )
}

@Composable
private fun PropertyLocationScreen(
    form: PropertyFormState,
    onCoordinateChanged: (HavnMapCoordinate) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val strings = LocalHavnStrings.current
    val address = form.fullAddress()
    val coordinate = form.mapCoordinate()
    var searchText by remember(address) { mutableStateOf(address) }
    var lookupText by remember(address) { mutableStateOf(address) }
    var lookupRequestId by remember { mutableStateOf(0) }
    val actionButtonModifier = Modifier.fillMaxWidth()
    val mapShape = RoundedCornerShape(8.dp)

    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
            HavnTextField(
                value = searchText,
                onValueChange = { searchText = it },
                label = strings.findLocation
            )
            HavnButton(
                text = strings.find,
                onClick = {
                    lookupText = searchText
                    lookupRequestId += 1
                },
                style = HavnButtonStyle.Secondary,
                modifier = actionButtonModifier,
                enabled = searchText.isNotBlank()
            )
            coordinate?.let {
                Text(it.locationLabel(), color = theme.mutedText, style = MaterialTheme.typography.bodySmall)
            }
        }
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(420.dp)
            .clip(mapShape)
            .border(BorderStroke(1.dp, theme.border), mapShape)
    ) {
        HavnPropertyMap(
            address = lookupText,
            searchRequestId = lookupRequestId,
            markerTitle = strings.propertyLocationMarkerTitle,
            missingTokenMessage = strings.mapKitJsMissingToken,
            loadingMessage = strings.mapKitJsLoading,
            coordinate = coordinate,
            onCoordinateChanged = onCoordinateChanged,
            modifier = Modifier.fillMaxSize()
        )
    }

}

@Composable
private fun PropertyOwnerContactCard(
    contacts: List<Client>,
    selectedContactId: String?,
    strings: com.havn.app.core.localization.HavnStrings,
    onSelect: (String?) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val selectedContact = contacts.firstOrNull { it.id == selectedContactId }
    var showPicker by remember { mutableStateOf(false) }
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
            Text(
                strings.propertyOwnerContactTitle,
                color = theme.primaryText,
                style = MaterialTheme.typography.titleLarge
            )
            if (contacts.isEmpty()) {
                Text(
                    strings.propertyOwnerNoContacts,
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.bodyMedium
                )
            } else {
                selectedContact?.let { contact ->
                    Text(
                        strings.propertyOwnerSelected,
                        color = theme.mutedText,
                        style = MaterialTheme.typography.labelLarge
                    )
                    OwnerContactRow(
                        contact = contact,
                        selected = true,
                        onClick = { showPicker = true }
                    )
                } ?: Text(
                    strings.propertyOwnerSelectContact,
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.bodyMedium
                )
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                ) {
                    HavnButton(
                        text = if (selectedContact == null) strings.propertyOwnerChooseContact else strings.propertyOwnerChangeContact,
                        onClick = { showPicker = true },
                        style = HavnButtonStyle.Secondary,
                        modifier = Modifier.weight(1f),
                        leadingIcon = HavnIconKey.Search
                    )
                    if (selectedContact != null) {
                        HavnButton(
                            text = strings.propertyOwnerRemoveContact,
                            onClick = { onSelect(null) },
                            style = HavnButtonStyle.Ghost,
                            modifier = Modifier.weight(1f),
                            leadingIcon = HavnIconKey.Trash
                        )
                    }
                }
            }
        }
    }
    if (showPicker) {
        OwnerContactPickerDialog(
            contacts = contacts,
            selectedContactId = selectedContactId,
            strings = strings,
            onDismiss = { showPicker = false },
            onSelect = { contactId ->
                onSelect(contactId)
                showPicker = false
            }
        )
    }
}

@Composable
private fun OwnerContactPickerDialog(
    contacts: List<Client>,
    selectedContactId: String?,
    strings: com.havn.app.core.localization.HavnStrings,
    onDismiss: () -> Unit,
    onSelect: (String) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    var query by remember { mutableStateOf("") }
    val normalizedQuery = query.trim()
    val matches = remember(contacts, normalizedQuery) {
        if (normalizedQuery.isBlank()) {
            emptyList()
        } else {
            contacts
                .asSequence()
                .filter { contact -> contact.matchesOwnerQuery(normalizedQuery) }
                .take(25)
                .toList()
        }
    }
    AlertDialog(
        onDismissRequest = onDismiss,
        containerColor = theme.card,
        titleContentColor = theme.primaryText,
        textContentColor = theme.secondaryText,
        title = { Text(strings.propertyOwnerPickerTitle) },
        text = {
            Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.md)) {
                HavnTextField(
                    value = query,
                    onValueChange = { query = it },
                    label = strings.propertyOwnerSearchContact,
                    leadingIcon = HavnIconKey.Search
                )
                Text(
                    if (normalizedQuery.isBlank()) strings.propertyOwnerSearchHint else "${matches.size} ${strings.clientsTitle.lowercase()}",
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.bodyMedium
                )
                if (normalizedQuery.isNotBlank() && matches.isEmpty()) {
                    Text(
                        strings.propertyOwnerNoMatches,
                        color = theme.mutedText,
                        style = MaterialTheme.typography.bodyMedium
                    )
                } else {
                    LazyColumn(
                        modifier = Modifier.heightIn(max = 360.dp),
                        verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)
                    ) {
                        items(matches, key = { it.id }) { contact ->
                            OwnerContactRow(
                                contact = contact,
                                selected = contact.id == selectedContactId,
                                onClick = { onSelect(contact.id) }
                            )
                        }
                    }
                }
            }
        },
        confirmButton = {
            TextButton(onClick = onDismiss) {
                Text(strings.commonCancel, color = theme.primaryAccent)
            }
        }
    )
}

@Composable
private fun OwnerContactRow(
    contact: Client,
    selected: Boolean,
    onClick: () -> Unit,
    trailingIcon: HavnIconKey = if (selected) HavnIconKey.Check else HavnIconKey.ArrowRight
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clip(MaterialTheme.shapes.medium)
            .clickable(onClick = onClick),
        shape = MaterialTheme.shapes.medium,
        color = if (selected) theme.primaryAccent.copy(alpha = 0.13f) else theme.surface,
        border = BorderStroke(1.dp, if (selected) theme.primaryAccent else theme.border)
    ) {
        Row(
            modifier = Modifier.padding(HavnSpacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(HavnSpacing.md)
        ) {
            Surface(
                modifier = Modifier.size(42.dp),
                shape = MaterialTheme.shapes.large,
                color = theme.primaryAccent.copy(alpha = if (selected) 0.28f else 0.14f),
                border = BorderStroke(1.dp, theme.primaryAccent.copy(alpha = 0.5f))
            ) {
                Box(contentAlignment = Alignment.Center) {
                    Text(
                        contact.initials,
                        color = theme.primaryText,
                        style = MaterialTheme.typography.labelLarge
                    )
                }
            }
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                Text(
                    contact.fullName,
                    color = theme.primaryText,
                    style = MaterialTheme.typography.bodyLarge,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    contact.contactLine,
                    color = theme.secondaryText,
                    style = MaterialTheme.typography.labelMedium,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            HavnIcon(
                icon = trailingIcon,
                contentDescription = null,
                tint = if (selected) theme.primaryAccent else theme.mutedText,
                modifier = Modifier.size(18.dp)
            )
        }
    }
}

private val Client.initials: String
    get() = listOf(firstName, lastName)
        .mapNotNull { value -> value?.trim()?.firstOrNull()?.uppercase() }
        .take(2)
        .joinToString("")
        .ifBlank { fullName.trim().take(2).uppercase().ifBlank { "C" } }

private fun Client.matchesOwnerQuery(query: String): Boolean {
    val lowerQuery = query.lowercase()
    return fullName.lowercase().contains(lowerQuery) ||
        email.orEmpty().lowercase().contains(lowerQuery) ||
        phone.orEmpty().lowercase().contains(lowerQuery)
}

@Composable
private fun StatusPicker(
    selected: PropertyStatus,
    strings: com.havn.app.core.localization.HavnStrings,
    onSelected: (PropertyStatus) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = MaterialTheme.shapes.medium,
        color = theme.surface,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(3.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            PropertyStatus.entries.forEachIndexed { index, status ->
                val isSelected = selected == status
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .heightIn(min = 44.dp)
                        .clip(MaterialTheme.shapes.small)
                        .background(if (isSelected) theme.primaryAccent else theme.surface)
                        .clickable { onSelected(status) }
                        .padding(horizontal = HavnSpacing.sm, vertical = HavnSpacing.sm),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = status.localizedLabel(strings),
                        color = if (isSelected) theme.background else theme.primaryText,
                        style = MaterialTheme.typography.labelLarge,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
                if (index != PropertyStatus.entries.lastIndex) {
                    Box(
                        modifier = Modifier
                            .width(1.dp)
                            .height(24.dp)
                            .background(theme.border)
                    )
                }
            }
        }
    }
}

@Composable
private fun ErrorPanel(error: String, onDismiss: () -> Unit, onUpgradePlan: () -> Unit = {}) {
    val strings = LocalHavnStrings.current
    val message = error.localizedPropertyError(strings)
    HavnCard {
        Column(verticalArrangement = Arrangement.spacedBy(HavnSpacing.sm)) {
            Text(message, color = HavnDanger, style = MaterialTheme.typography.bodyLarge)
            if (message.isUpgradePrompt()) {
                HavnButton(
                    text = strings.upgradePlan,
                    onClick = onUpgradePlan,
                    style = HavnButtonStyle.Primary,
                    modifier = Modifier.fillMaxWidth()
                )
            }
            HavnButton(
                text = strings.commonDismiss,
                onClick = onDismiss,
                style = HavnButtonStyle.Ghost,
                modifier = Modifier.fillMaxWidth()
            )
        }
    }
}

private fun String.localizedPropertyError(strings: com.havn.app.core.localization.HavnStrings): String {
    val normalized = lowercase()
    return when {
        "photo limit reached" in normalized ||
            ("max_photos_per_property" in normalized) ->
            strings.propertyPhotoCountPlanLimit
        "storage limit reached" in normalized ->
            strings.propertyPhotoStoragePlanLimit
        else -> this
    }
}

private fun String.isUpgradePrompt(): Boolean {
    val normalized = lowercase()
    return "upgrade" in normalized || "current plan" in normalized || "limit reached" in normalized || "storage limit" in normalized
}

@Composable
private fun BoxScope.PropertyImageHeader(
    property: Property,
    selectedPhoto: PropertyPhoto? = null,
    preferListThumbnail: Boolean = false,
    dimImage: Boolean = false
) {
    val heroPhoto = selectedPhoto
        ?: property.photos.firstOrNull { it.storagePath == property.heroPhotoPath }
        ?: property.photos.firstOrNull { it.isHero }
        ?: property.photos.firstOrNull()
    PropertyImageHeaderContent(
        property = property,
        photo = heroPhoto,
        preferListThumbnail = preferListThumbnail
    )
    if (dimImage) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(
                    Brush.verticalGradient(
                        listOf(androidx.compose.ui.graphics.Color.Transparent, androidx.compose.ui.graphics.Color(0xCC05080D))
                    )
                )
        )
    }
}

@Composable
private fun BoxScope.PropertyImageHeaderContent(
    property: Property,
    photo: PropertyPhoto?,
    preferListThumbnail: Boolean
) {
    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        val listSource = photo?.listThumbnailDataUrl?.takeIf { preferListThumbnail }
        val fullSizeSource = if (preferListThumbnail) {
            null
        } else {
            havnLargePropertyPhotoSource(photo?.storagePath)
                ?.takeUnless { it == photo?.thumbnailDataUrl }
        }
        val rendered = if (preferListThumbnail) {
            HavnAsyncImage(
                dataUrl = listSource ?: photo?.thumbnailDataUrl,
                contentDescription = property.title,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Crop
            )
        } else {
            HavnDatabaseImage(
                dataUrl = listSource ?: fullSizeSource ?: photo?.thumbnailDataUrl,
                previewDataUrl = listSource ?: photo?.thumbnailDataUrl,
                contentDescription = property.title,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.Crop
            )
        }
        if (!rendered) {
            HavnSkeletonBlock(Modifier.fillMaxSize(), shape = MaterialTheme.shapes.small)
        }
    }
}

@Composable
private fun PendingPropertyPhotoTile(
    photo: HavnPickedPhoto,
    index: Int,
    mainLabel: String,
    removeLabel: String,
    onRemove: () -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    Surface(
        modifier = Modifier.width(150.dp),
        color = theme.surface,
        shape = MaterialTheme.shapes.medium,
        border = BorderStroke(1.dp, theme.border)
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(8.dp), modifier = Modifier.padding(8.dp)) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(104.dp)
                    .clip(MaterialTheme.shapes.small)
                    .background(theme.surfaceElevated),
                contentAlignment = Alignment.Center
            ) {
                val rendered = HavnDatabaseImage(
                    dataUrl = photo.thumbnailDataUrl,
                    contentDescription = photo.fileName,
                    modifier = Modifier.fillMaxSize(),
                    contentScale = ContentScale.Crop
                )
                if (!rendered) {
                    HavnIcon(HavnIconKey.Home, contentDescription = null, tint = theme.secondaryText, modifier = Modifier.size(28.dp))
                }
            }
            Text(
                text = if (index == 0) mainLabel else photo.fileName,
                color = theme.primaryText,
                style = MaterialTheme.typography.labelMedium,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            HavnButton(
                text = removeLabel,
                onClick = onRemove,
                style = HavnButtonStyle.Secondary,
                modifier = Modifier.fillMaxWidth(),
                leadingIcon = HavnIconKey.Trash
            )
        }
    }
}

@Composable
private fun PropertyPhotoTile(
    photo: PropertyPhoto,
    index: Int,
    mainLabel: String,
    imageDescription: String,
    deleteDescription: String,
    onDelete: () -> Unit,
    onReorder: (Int) -> Unit,
    onMakeMain: () -> Unit,
    onDragScroll: (Float) -> Unit
) {
    val theme = LocalHavnThemeTokens.current
    val density = LocalDensity.current
    val tileSize = 80.dp
    val tileStepPx = with(density) { (tileSize + HavnSpacing.sm).toPx() }
    var dragOffsetX by remember(photo.id) { mutableStateOf(0f) }
    var isDragging by remember(photo.id) { mutableStateOf(false) }
    val dragProgress = (kotlin.math.abs(dragOffsetX) / tileStepPx).coerceIn(0f, 1f)
    val animatedOffsetX by animateFloatAsState(
        targetValue = dragOffsetX,
        animationSpec = spring(
            dampingRatio = if (isDragging) Spring.DampingRatioNoBouncy else Spring.DampingRatioMediumBouncy,
            stiffness = if (isDragging) Spring.StiffnessMediumLow else Spring.StiffnessLow
        ),
        label = "property-photo-drag-offset"
    )
    val liftScale by animateFloatAsState(
        targetValue = if (isDragging) 1.07f else 1f,
        animationSpec = spring(dampingRatio = Spring.DampingRatioMediumBouncy, stiffness = Spring.StiffnessMediumLow),
        label = "property-photo-lift-scale"
    )
    val imageScale by animateFloatAsState(
        targetValue = if (isDragging) 1.045f else 1f,
        animationSpec = spring(dampingRatio = Spring.DampingRatioNoBouncy, stiffness = Spring.StiffnessMediumLow),
        label = "property-photo-image-scale"
    )
    val tileShadow by animateDpAsState(
        targetValue = if (isDragging) 24.dp else 0.dp,
        animationSpec = spring(dampingRatio = Spring.DampingRatioNoBouncy, stiffness = Spring.StiffnessMediumLow),
        label = "property-photo-shadow"
    )
    val borderColor by animateColorAsState(
        targetValue = when {
            isDragging -> theme.primaryAccent.copy(alpha = 0.96f)
            index == 0 -> theme.primaryAccent.copy(alpha = 0.9f)
            else -> theme.primaryAccent.copy(alpha = 0.28f)
        },
        animationSpec = spring(dampingRatio = Spring.DampingRatioNoBouncy, stiffness = Spring.StiffnessMediumLow),
        label = "property-photo-border"
    )
    val glowAlpha by animateFloatAsState(
        targetValue = if (isDragging) 0.34f + (dragProgress * 0.22f) else 0f,
        animationSpec = spring(dampingRatio = Spring.DampingRatioNoBouncy, stiffness = Spring.StiffnessMediumLow),
        label = "property-photo-glow"
    )
    val deleteAlpha by animateFloatAsState(
        targetValue = if (isDragging) 0.18f else 1f,
        animationSpec = spring(dampingRatio = Spring.DampingRatioNoBouncy, stiffness = Spring.StiffnessMediumLow),
        label = "property-photo-delete-alpha"
    )
    val dragDirection = when {
        dragOffsetX > 16f -> 1f
        dragOffsetX < -16f -> -1f
        else -> 0f
    }
    Column(
        modifier = Modifier
            .width(tileSize)
            .padding(vertical = 10.dp)
            .zIndex(if (isDragging) 1f else 0f)
            .offset { IntOffset(animatedOffsetX.roundToInt(), 0) }
            .graphicsLayer {
                scaleX = liftScale
                scaleY = liftScale
                rotationZ = dragDirection * 2.4f * dragProgress
            }
            .pointerInput(photo.id, index) {
                detectDragGesturesAfterLongPress(
                    onDragStart = {
                        dragOffsetX = 0f
                        isDragging = true
                    },
                    onDragCancel = {
                        dragOffsetX = 0f
                        isDragging = false
                    },
                    onDragEnd = {
                        val targetIndex = (index + (dragOffsetX / tileStepPx).roundToInt()).coerceAtLeast(0)
                        dragOffsetX = 0f
                        isDragging = false
                        onReorder(targetIndex)
                    },
                    onDrag = { change, dragAmount ->
                        change.consume()
                        dragOffsetX += dragAmount.x * (1f - (dragProgress * 0.08f))
                        onDragScroll(dragAmount.x * 0.78f)
                    }
                )
            },
        verticalArrangement = Arrangement.spacedBy(HavnSpacing.xs)
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(tileSize)
                .shadow(tileShadow, MaterialTheme.shapes.medium, clip = false)
                .clip(MaterialTheme.shapes.medium)
                .background(theme.surface)
                .border(1.dp, borderColor, MaterialTheme.shapes.medium)
                .clickable(onClick = onMakeMain)
        ) {
            Box(
                modifier = Modifier
                    .matchParentSize()
                    .background(
                        Brush.radialGradient(
                            colors = listOf(
                                theme.primaryAccent.copy(alpha = glowAlpha),
                                Color.Transparent
                            )
                        )
                    )
            )
            val rendered = HavnDatabaseImage(
                dataUrl = photo.thumbnailDataUrl,
                previewDataUrl = havnPropertyPhotoPreviewSource(photo.thumbnailDataUrl, 160),
                contentDescription = photo.altText ?: imageDescription,
                modifier = Modifier
                    .fillMaxSize()
                    .graphicsLayer {
                        scaleX = imageScale
                        scaleY = imageScale
                    },
                contentScale = ContentScale.Crop
            )
            if (!rendered) {
                HavnSkeletonBlock(Modifier.fillMaxSize(), shape = MaterialTheme.shapes.small)
                HavnIcon(
                    icon = HavnIconKey.Properties,
                    contentDescription = null,
                    tint = theme.primaryAccent,
                    modifier = Modifier
                        .align(Alignment.Center)
                        .size(14.dp)
                )
            }
            if (isDragging) {
                Box(
                    modifier = Modifier
                        .matchParentSize()
                        .background(
                            Brush.verticalGradient(
                                listOf(
                                    Color.White.copy(alpha = 0.10f),
                                    theme.primaryAccent.copy(alpha = 0.08f),
                                    Color.Transparent
                                )
                            )
                        )
                )
            }
            if (index == 0) {
                Text(
                    mainLabel,
                    modifier = Modifier
                        .align(Alignment.BottomStart)
                        .background(theme.primaryAccent.copy(alpha = 0.92f), MaterialTheme.shapes.small)
                        .padding(horizontal = 4.dp, vertical = 2.dp),
                    color = theme.background,
                    style = MaterialTheme.typography.labelSmall
                )
            }
            Box(
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .padding(HavnSpacing.xs)
                    .size(32.dp)
                    .alpha(deleteAlpha)
                    .clip(MaterialTheme.shapes.small)
                    .background(Color(0xCC05080D))
                    .clickable(onClick = onDelete),
                contentAlignment = Alignment.Center
            ) {
                HavnIcon(
                    icon = HavnIconKey.Trash,
                    contentDescription = deleteDescription,
                    tint = HavnDanger,
                    modifier = Modifier.size(18.dp)
                )
            }
            if (isDragging) {
                Box(
                    modifier = Modifier
                        .align(Alignment.BottomCenter)
                        .padding(bottom = HavnSpacing.xs)
                        .height(14.dp)
                        .width(29.dp)
                        .clip(CircleShape)
                        .background(theme.surface.copy(alpha = 0.82f))
                        .border(1.dp, theme.primaryAccent.copy(alpha = 0.72f), CircleShape),
                    contentAlignment = Alignment.Center
                ) {
                    HavnIcon(
                        icon = HavnIconKey.ArrowRight,
                        contentDescription = null,
                        tint = theme.primaryAccent,
                        modifier = Modifier
                            .size(9.dp)
                            .graphicsLayer { rotationZ = if (dragDirection < 0f) 180f else 0f }
                    )
                }
            }
        }
    }
}

private fun PropertyStatus.toHavnStatus(): HavnStatus = when (this) {
    PropertyStatus.Active -> HavnStatus.Active
    PropertyStatus.Planned -> HavnStatus.Planned
    PropertyStatus.Archived -> HavnStatus.Archived
}

private fun PropertyStatus.localizedLabel(strings: com.havn.app.core.localization.HavnStrings): String = when (this) {
    PropertyStatus.Active -> strings.commonActive
    PropertyStatus.Planned -> strings.commonPlanned
    PropertyStatus.Archived -> strings.commonArchived
}

private fun List<PropertyPhoto>.orderedBy(photoOrderIds: List<String>): List<PropertyPhoto> {
    if (photoOrderIds.isEmpty()) return this
    val byId = associateBy { it.id }
    val ordered = photoOrderIds.mapNotNull { byId[it] }
    return ordered + filterNot { it.id in photoOrderIds }
}

private fun String.localizedPropertyValidation(strings: com.havn.app.core.localization.HavnStrings): String = when (this) {
    "Property title is required." -> strings.propertyTitleRequired
    "Street address is required." -> strings.propertyStreetRequired
    "City is required." -> strings.propertyCityRequired
    "State or region is required." -> strings.propertyRegionRequired
    "Postal code is required." -> strings.propertyPostalRequired
    "Enter a valid asking price." -> strings.propertyAskingPriceInvalid
    else -> this
}

private fun String.numberText(): String = filter { it.isDigit() || it == '.' }.let { value ->
    val firstDot = value.indexOf('.')
    if (firstDot == -1) value else value.take(firstDot + 1) + value.drop(firstDot + 1).replace(".", "")
}

private fun PropertyFormState.fullAddress(): String =
    listOf(addressLine1, addressLine2, city, region, postalCode, country)
        .map { it.trim() }
        .filter { it.isNotBlank() }
        .joinToString(", ")

private fun PropertyFormState.mapCoordinate(): HavnMapCoordinate? {
    val lat = latitude ?: return null
    val lng = longitude ?: return null
    return HavnMapCoordinate(lat, lng)
}

private fun Property.mapCoordinate(): HavnMapCoordinate? {
    val lat = latitude ?: return null
    val lng = longitude ?: return null
    return HavnMapCoordinate(lat, lng)
}

private fun PropertyFormState.locationLabel(): String? =
    mapCoordinate()?.locationLabel()

private fun HavnMapCoordinate.locationLabel(): String =
    "${latitude.formatCoordinate()}, ${longitude.formatCoordinate()}"

private fun String.initials(): String =
    trim()
        .split(" ")
        .filter { it.isNotBlank() }
        .take(2)
        .joinToString("") { it.first().uppercase() }
        .ifBlank { "?" }

private fun Double.formatCoordinate(): String =
    (kotlin.math.round(this * 100000.0) / 100000.0).toString()

private fun String.displayDateTime(): String =
    readablePropertyDateTime()

private fun String.readablePropertyDateTime(): String {
    val clean = replace("T", " ").substringBefore(".").substringBefore("+").substringBefore("Z")
    val date = clean.substringBefore(" ").readablePropertyDate()
    val time = clean.substringAfter(" ", "").readablePropertyTime()
    return listOfNotNull(date, time).joinToString(" · ").ifBlank { clean }
}

private fun String.readablePropertyDate(): String? {
    val parts = split("-")
    if (parts.size != 3) return null
    val month = parts[1].toIntOrNull()?.let { propertyMonthNames.getOrNull(it - 1) } ?: return null
    val day = parts[2].toIntOrNull() ?: return null
    return "$month $day"
}

private fun String.readablePropertyTime(): String? {
    if (":" !in this) return null
    val hour = substringBefore(":").toIntOrNull() ?: return null
    val minute = substringAfter(":").take(2).padStart(2, '0')
    val displayHour = when {
        hour == 0 -> 12
        hour > 12 -> hour - 12
        else -> hour
    }
    val suffix = if (hour >= 12) "PM" else "AM"
    return "$displayHour:$minute $suffix"
}

private val propertyMonthNames = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")

private fun PropertiesMode.navigationDepth(): Int = when (this) {
    PropertiesMode.List -> 0
    PropertiesMode.Detail,
    PropertiesMode.Add -> 1
    PropertiesMode.Inquiries -> 2
    PropertiesMode.InquiryDetail,
    PropertiesMode.AddInquiry -> 3
    PropertiesMode.Edit -> 2
    PropertiesMode.Locate -> 3
}
